var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpoweringAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 3000 2500",
    viewBox: "0 0 3000 2500",
    id: "Checktherocketlaunchdataanalysis",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2918.64,
    height: 2432.2,
    x: 40.68,
    y: 33.9,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.27,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1383.46,
    cy: 1776.45,
    fill: "#00114c",
    opacity: 0,
    rx: 554.3,
    ry: 227.55,
    transform: "rotate(-1.621 1383.269 1778.703)",
    className: "color4c0000 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1382.94,
    cy: 1775.85,
    fill: "#01124a",
    opacity: 0.038,
    rx: 538.72,
    ry: 221.16,
    transform: "rotate(-1.621 1382.752 1778.094)",
    className: "color4a0101 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1382.42,
    cy: 1775.24,
    fill: "#021248",
    opacity: 0.077,
    rx: 523.15,
    ry: 214.77,
    transform: "rotate(-1.621 1382.232 1777.485)",
    className: "color480202 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1381.91,
    cy: 1774.64,
    fill: "#031246",
    opacity: 0.115,
    rx: 507.58,
    ry: 208.37,
    transform: "rotate(-1.621 1381.712 1776.876)",
    className: "color460303 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1381.39,
    cy: 1774.04,
    fill: "#041344",
    opacity: 0.154,
    rx: 492,
    ry: 201.98,
    transform: "rotate(-1.621 1381.192 1776.267)",
    className: "color440404 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1380.88,
    cy: 1773.44,
    fill: "#051342",
    opacity: 0.192,
    rx: 476.43,
    ry: 195.59,
    transform: "rotate(-1.621 1380.668 1775.658)",
    className: "color420505 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1380.36,
    cy: 1772.83,
    fill: "#061340",
    opacity: 0.231,
    rx: 460.86,
    ry: 189.19,
    transform: "rotate(-1.621 1380.148 1775.046)",
    className: "color400606 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1379.85,
    cy: 1772.23,
    fill: "#06133e",
    opacity: 0.269,
    rx: 445.28,
    ry: 182.8,
    transform: "rotate(-1.621 1379.628 1774.437)",
    className: "color3e0606 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1379.33,
    cy: 1771.63,
    fill: "#07133c",
    opacity: 0.308,
    rx: 429.71,
    ry: 176.41,
    transform: "rotate(-1.621 1379.104 1773.824)",
    className: "color3c0707 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1378.82,
    cy: 1771.02,
    fill: "#08133a",
    opacity: 0.346,
    rx: 414.14,
    ry: 170.01,
    transform: "rotate(-1.621 1378.584 1773.211)",
    className: "color3a0808 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1378.3,
    cy: 1770.42,
    fill: "#091438",
    opacity: 0.385,
    rx: 398.57,
    ry: 163.62,
    transform: "rotate(-1.621 1378.06 1772.599)",
    className: "color380909 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1377.78,
    cy: 1769.82,
    fill: "#0a1436",
    opacity: 0.423,
    rx: 382.99,
    ry: 157.23,
    transform: "rotate(-1.621 1377.536 1771.986)",
    className: "color360a0a svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1377.27,
    cy: 1769.22,
    fill: "#0b1434",
    opacity: 0.462,
    rx: 367.42,
    ry: 150.83,
    transform: "rotate(-1.621 1377.013 1771.37)",
    className: "color340b0b svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1376.75,
    cy: 1768.61,
    fill: "#0c1533",
    opacity: 0.5,
    rx: 351.85,
    ry: 144.44,
    transform: "rotate(-1.621 1376.489 1770.757)",
    className: "color330c0c svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1376.24,
    cy: 1768.01,
    fill: "#0d1531",
    opacity: 0.538,
    rx: 336.27,
    ry: 138.05,
    transform: "rotate(-1.621 1375.962 1770.14)",
    className: "color310d0d svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1375.72,
    cy: 1767.41,
    fill: "#0e162f",
    opacity: 0.577,
    rx: 320.7,
    ry: 131.65,
    transform: "rotate(-1.621 1375.434 1769.52)",
    className: "color2f0e0e svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1375.21,
    cy: 1766.8,
    fill: "#0f162d",
    opacity: 0.615,
    rx: 305.13,
    ry: 125.26,
    transform: "rotate(-1.621 1374.907 1768.904)",
    className: "color2d0f0f svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1374.69,
    cy: 1766.2,
    fill: "#10162b",
    opacity: 0.654,
    rx: 289.55,
    ry: 118.87,
    transform: "rotate(-1.621 1374.38 1768.28)",
    className: "color2b1010 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1374.18,
    cy: 1765.6,
    fill: "#111729",
    opacity: 0.692,
    rx: 273.98,
    ry: 112.47,
    transform: "rotate(-1.621 1373.85 1767.66)",
    className: "color291111 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1373.66,
    cy: 1765,
    fill: "#121727",
    opacity: 0.731,
    rx: 258.41,
    ry: 106.08,
    transform: "rotate(-1.621 1373.315 1767.034)",
    className: "color271212 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1373.14,
    cy: 1764.39,
    fill: "#121625",
    opacity: 0.769,
    rx: 242.83,
    ry: 99.69,
    transform: "rotate(-1.621 1372.78 1766.406)",
    className: "color251212 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1372.63,
    cy: 1763.79,
    fill: "#131723",
    opacity: 0.808,
    rx: 227.26,
    ry: 93.29,
    transform: "rotate(-1.621 1372.242 1765.775)",
    className: "color231313 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1372.11,
    cy: 1763.19,
    fill: "#141721",
    opacity: 0.846,
    rx: 211.69,
    ry: 86.9,
    transform: "rotate(-1.621 1371.704 1765.14)",
    className: "color211414 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1371.6,
    cy: 1762.58,
    fill: "#15171f",
    opacity: 0.885,
    rx: 196.11,
    ry: 80.51,
    transform: "rotate(-1.621 1371.16 1764.502)",
    className: "color1f1515 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1371.08,
    cy: 1761.98,
    fill: "#16181d",
    opacity: 0.923,
    rx: 180.54,
    ry: 74.11,
    transform: "rotate(-1.621 1370.61 1763.857)",
    className: "color1d1616 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1370.57,
    cy: 1761.38,
    fill: "#17181b",
    opacity: 0.962,
    rx: 164.97,
    ry: 67.72,
    transform: "rotate(-1.621 1370.055 1763.204)",
    className: "color1b1717 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1370.05,
    cy: 1760.78,
    fill: "#181819",
    rx: 149.39,
    ry: 61.33,
    transform: "rotate(-1.621 1369.489 1762.54)",
    className: "color191818 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1110.122,
    x2: 2265.367,
    y1: 973.324,
    y2: 973.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M1143.02,1241.84l911.22,171.53c21.46,4.04,42.24-9.73,46.89-31.07l163.31-750.07 c5.28-24.26-12.39-47.48-37.17-48.87l-909.53-50.74c-19.15-1.07-36.41,11.5-41.27,30.05l-165,629.28 C1105.52,1214.6,1120.02,1237.52,1143.02,1241.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2203.122,
    x2: 1015.444,
    y1: 800.038,
    y2: 1136.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1124.09,1219.76l911.22,171.53c21.46,4.04,42.24-9.73,46.89-31.07l163.31-750.07 c5.28-24.26-12.39-47.48-37.17-48.87l-909.53-50.74c-19.15-1.07-36.41,11.5-41.27,30.05l-165,629.28 C1086.59,1192.51,1101.09,1215.43,1124.09,1219.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1494.826,
    x2: 1978.331,
    y1: 713.579,
    y2: 1206.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d4fd",
    className: "stopColorc8ecfd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M2042.82,1368.94c-1.09,0-2.17-0.09-3.26-0.3l-911.22-171.54c-4.77-0.89-8.82-3.64-11.41-7.73 c-2.59-4.1-3.34-8.95-2.12-13.65l164.99-629.27c2.01-7.61,8.9-12.92,16.73-12.92l910.5,50.78c6.94,0.38,10.99,4.41,12.79,6.78 c1.83,2.38,4.63,7.37,3.15,14.16l-163.32,750.07C2057.94,1363.22,2050.87,1368.94,2042.82,1368.94L2042.82,1368.94z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1850.32,
    x2: 1359.525,
    y1: 1600.305,
    y2: 1600.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1154.25,1282.35l900.17,136.01c19.13,3.54,24.48,58.34,9.65,71.16l-471.04,407.02 c-25.84,22.33-61.37,29.25-93.42,18.19l-836.34-288.54c-25.91-8.94-47.98-73.38-24.72-88.16l444.48-241.78 C1104.25,1282.76,1129.67,1277.8,1154.25,1282.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1849.859,
    x2: 1359.064,
    y1: 1598.693,
    y2: 1598.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbfb",
    className: "stopColorfbfbfb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ececec",
    className: "stopColorececec svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M1153.79,1280.74l900.17,136.01c19.13,3.54,24.48,58.34,9.65,71.16l-471.04,407.02 c-25.84,22.33-61.37,29.25-93.42,18.19l-836.34-288.54c-25.91-8.94-47.98-73.38-24.72-88.16l444.48-241.78 C1103.79,1281.15,1129.21,1276.19,1153.79,1280.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 632.903,
    x2: 2063.219,
    y1: 1563.318,
    y2: 1563.318,
    gradientTransform: "matrix(1 0 -.00485 .9987 5.229 1.437)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbfb",
    className: "stopColorfbfbfb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ececec",
    className: "stopColorececec svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1143.5,1244.72l899.11,166.4c19.13,3.54,25.54,27.95,10.71,40.77l-471.04,407.02 c-25.84,22.33-61.37,29.25-93.42,18.19l-836.34-288.54c-25.91-8.94-29.85-44.3-6.59-59.07l426.35-270.87 C1093.5,1245.13,1118.92,1240.17,1143.5,1244.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2053.32,1449.47l-471.04,407.02c-25.84,22.33-61.37,29.25-93.42,18.19l-836.34-288.54 c-12.89-4.45-20.31-15.43-21.69-27.17c0.58,12.62,7.92,24.83,21.69,29.58l836.34,288.54c32.05,11.06,67.58,4.14,93.42-18.19 l471.04-407.02c5.94-5.13,8.34-12.11,8.01-18.87C2061.01,1438.99,2058.55,1444.95,2053.32,1449.47z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 1026.562,
    x2: 2234.916,
    y1: 1292.967,
    y2: 1351.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1101.37,1306.62c13.44,2.89,20.21,4.34,33.85,7.26c5.05,1.08,11.82,0.08,15.05-2.25 c8.72-6.29,12.99-9.46,21.3-15.88c3.08-2.38,1.41-5.17-3.65-6.21c-13.66-2.8-20.44-4.2-33.89-6.98 c-4.99-1.03-11.47,0.06-14.55,2.41c-8.32,6.34-12.58,9.44-21.26,15.6C1095.01,1302.85,1096.39,1305.55,1101.37,1306.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 993.764,
    x2: 2226.511,
    y1: 1303.024,
    y2: 1363.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M1241.2,1304.49c-14.05-2.85-21.03-4.27-34.9-7.1c-5.14-1.05-11.75,0.06-14.83,2.45 c-8.31,6.46-12.59,9.65-21.32,15.99c-3.23,2.35-1.75,5.13,3.38,6.22c13.85,2.95,20.82,4.43,34.83,7.4 c5.19,1.1,12.09,0.05,15.35-2.35c8.78-6.48,13.07-9.74,21.39-16.3C1248.18,1308.38,1246.41,1305.55,1241.2,1304.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 959.77,
    x2: 2212.993,
    y1: 1313.147,
    y2: 1374.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M1316.3,1319.6c-14.35-2.87-21.49-4.3-35.71-7.16c-5.27-1.06-11.98,0.07-15.07,2.52 c-8.32,6.6-12.62,9.88-21.42,16.42c-3.26,2.42-1.7,5.28,3.55,6.39c14.17,2.99,21.3,4.49,35.6,7.49c5.3,1.11,12.31,0,15.6-2.48 c8.86-6.69,13.19-10.04,21.53-16.75C1323.48,1323.54,1321.62,1320.67,1316.3,1319.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 925.16,
    x2: 2194.851,
    y1: 1323.267,
    y2: 1385.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1323.3,1353.63c14.42,3.01,21.66,4.51,36.17,7.52c5.38,1.11,12.48-0.07,15.81-2.63 c8.96-6.91,13.32-10.36,21.71-17.22c3.11-2.54,1.19-5.46-4.21-6.52c-14.57-2.86-21.83-4.3-36.3-7.17 c-5.36-1.06-12.16,0.1-15.26,2.6c-8.36,6.75-12.69,10.12-21.58,16.87C1316.35,1349.58,1317.96,1352.51,1323.3,1353.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 890.545,
    x2: 2172.606,
    y1: 1333.319,
    y2: 1395.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M1400.04,1369.51c14.59,3,21.9,4.5,36.53,7.49c5.42,1.11,12.6-0.15,15.96-2.8 c9.08-7.14,13.48-10.69,21.93-17.72c3.13-2.61,1.19-5.56-4.26-6.61c-14.7-2.84-22.04-4.27-36.69-7.12 c-5.43-1.06-12.29,0.15-15.4,2.71c-8.4,6.91-12.78,10.38-21.77,17.36C1393,1365.4,1394.63,1368.4,1400.04,1369.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 856.562,
    x2: 2146.812,
    y1: 1343.241,
    y2: 1406.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M1477.43,1385.31c14.67,2.97,22.01,4.45,36.69,7.4c5.44,1.09,12.67-0.26,16.08-2.99 c9.2-7.38,13.66-11.03,22.18-18.24c3.16-2.67,1.22-5.66-4.25-6.69c-14.76-2.8-22.14-4.21-36.88-7.03 c-5.46-1.05-12.37,0.22-15.51,2.84c-8.47,7.08-12.89,10.65-22,17.86C1470.37,1381.14,1471.99,1384.21,1477.43,1385.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 823.865,
    x2: 2118.061,
    y1: 1352.967,
    y2: 1416.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M1626.12,1379.43c-14.73-2.73-22.1-4.11-36.85-6.88c-5.47-1.03-12.4,0.3-15.56,2.99 c-8.54,7.26-13.02,10.94-22.26,18.38c-3.43,2.76-1.85,5.89,3.59,6.98c14.67,2.92,22.01,4.37,36.65,7.26 c5.43,1.07,12.69-0.37,16.15-3.2c9.34-7.62,13.86-11.39,22.46-18.77C1633.49,1383.46,1631.58,1380.44,1626.12,1379.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 793.133,
    x2: 2086.961,
    y1: 1362.438,
    y2: 1425.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M1703.74,1393.67c-14.62-2.65-21.94-3.98-36.62-6.67c-5.44-1-12.37,0.4-15.57,3.16 c-8.63,7.44-13.16,11.23-22.54,18.92c-3.48,2.85-1.97,6.04,3.44,7.1c14.59,2.85,21.87,4.26,36.4,7.07 c5.38,1.04,12.65-0.51,16.17-3.43c9.49-7.87,14.07-11.74,22.77-19.31C1711.01,1397.68,1709.16,1394.65,1703.74,1393.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 765.043,
    x2: 2054.154,
    y1: 1371.59,
    y2: 1434.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M1780.55,1407.39c-14.42-2.54-21.66-3.82-36.19-6.42c-5.38-0.96-12.29,0.51-15.53,3.34 c-8.72,7.62-13.32,11.52-22.86,19.46c-3.53,2.94-2.12,6.18,3.23,7.2c14.43,2.75,21.62,4.11,35.95,6.81 c5.31,1,12.57-0.66,16.14-3.67c9.65-8.12,14.3-12.1,23.09-19.86C1787.66,1411.38,1785.9,1408.33,1780.55,1407.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 740.299,
    x2: 2020.29,
    y1: 1380.363,
    y2: 1442.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M1784.91,1445.22c14.19,2.63,21.25,3.93,35.29,6.5c5.2,0.95,12.43-0.83,16.06-3.93 c9.81-8.37,14.53-12.46,23.44-20.4c3.3-2.94,1.65-6.01-3.59-6.9c-14.14-2.41-21.26-3.63-35.54-6.11 c-5.29-0.92-12.16,0.64-15.43,3.54c-8.83,7.81-13.49,11.82-23.19,20.01C1778.36,1440.96,1779.66,1444.24,1784.91,1445.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 719.577,
    x2: 1986.039,
    y1: 1388.696,
    y2: 1450.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M1929.98,1432.85c-13.78-2.26-20.72-3.41-34.69-5.74c-5.17-0.86-11.98,0.78-15.29,3.75 c-8.93,7.99-13.68,12.12-23.53,20.55c-3.65,3.13-2.51,6.45,2.63,7.37c13.86,2.49,20.75,3.72,34.43,6.13 c5.07,0.9,12.24-1.01,15.93-4.2c9.98-8.61,14.78-12.82,23.79-20.94C1936.6,1436.75,1935.09,1433.68,1929.98,1432.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 985.543,
    x2: 2020.423,
    y1: 1331.791,
    y2: 1382.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M1196.59,1337.89c-8.87-1.92-13.29-2.88-22.1-4.79c-5.08-1.1-7.61-1.65-12.67-2.75 c-29.24-6.35-43.69-9.51-72.07-15.72c-4.97-1.09-11.67-0.15-15.01,2.09c-9.02,6.03-13.61,9.02-22.9,15 c-3.44,2.22-2.27,4.94,2.68,6.1c28.23,6.59,42.59,9.94,71.65,16.69c5.03,1.17,7.55,1.75,12.59,2.93 c8.75,2.03,13.14,3.05,21.96,5.09c5.15,1.19,12.22,0.22,15.74-2.17c9.51-6.45,14.2-9.67,23.39-16.11 C1203.26,1341.86,1201.77,1339.01,1196.59,1337.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 898.342,
    x2: 2189.547,
    y1: 1346.599,
    y2: 1409.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M1271.35,1353.99c-14.27-3.06-21.38-4.59-35.53-7.63c-5.24-1.13-12.22-0.08-15.64,2.33 c-9.22,6.52-13.93,9.77-23.48,16.3c-3.54,2.42-2.22,5.36,2.98,6.56c14.05,3.25,21.11,4.87,35.28,8.14 c5.25,1.21,12.44,0.16,16.02-2.34c9.66-6.74,14.42-10.1,23.74-16.8C1278.17,1358.06,1276.64,1355.13,1271.35,1353.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 858.865,
    x2: 2169.568,
    y1: 1357.727,
    y2: 1421.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M1274.62,1388.8c14.28,3.27,21.45,4.91,35.81,8.19c5.32,1.21,12.62,0.08,16.26-2.53 c9.82-7.04,14.67-10.54,24.12-17.52c3.5-2.59,1.95-5.6-3.41-6.73c-14.48-3.07-21.7-4.6-36.09-7.67 c-5.33-1.14-12.42-0.02-15.89,2.49c-9.36,6.78-14.14,10.18-23.84,17C1267.99,1384.55,1269.33,1387.58,1274.62,1388.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 818.753,
    x2: 2144.995,
    y1: 1368.812,
    y2: 1433.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M1350.57,1406.12c14.43,3.28,21.66,4.92,36.14,8.19c5.36,1.21,12.75-0.02,16.46-2.75 c10-7.35,14.93-11,24.55-18.26c3.56-2.69,2.02-5.78-3.39-6.91c-14.6-3.05-21.89-4.58-36.45-7.65 c-5.39-1.14-12.57,0.06-16.09,2.67c-9.5,7.05-14.37,10.59-24.24,17.72C1343.89,1401.78,1345.22,1404.91,1350.57,1406.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 778.614,
    x2: 2116.357,
    y1: 1379.778,
    y2: 1445.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M1427.1,1423.41c14.5,3.26,21.76,4.88,36.26,8.12c5.38,1.2,12.83-0.14,16.61-2.98 c10.2-7.67,15.22-11.47,25.01-19.02c3.63-2.8,2.12-5.95-3.3-7.07c-14.64-3.02-21.97-4.53-36.6-7.57 c-5.42-1.13-12.68,0.15-16.26,2.87c-9.66,7.33-14.62,11.03-24.67,18.46C1420.42,1418.98,1421.73,1422.2,1427.1,1423.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 739.056,
    x2: 2084.231,
    y1: 1390.549,
    y2: 1456.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M1579.04,1418.26c-14.6-2.96-21.92-4.44-36.55-7.43c-5.42-1.11-12.73,0.27-16.37,3.09 c-9.83,7.62-14.88,11.47-25.14,19.23c-3.8,2.87-2.56,6.18,2.82,7.37c14.49,3.21,21.73,4.81,36.19,7.99 c5.36,1.18,12.85-0.28,16.71-3.24c10.4-7.99,15.53-11.95,25.49-19.79C1585.89,1422.58,1584.45,1419.35,1579.04,1418.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 700.705,
    x2: 2049.199,
    y1: 1401.052,
    y2: 1466.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M1655.97,1433.68c-14.48-2.87-21.75-4.32-36.29-7.24c-5.39-1.08-12.73,0.4-16.44,3.33 c-10.02,7.91-15.17,11.92-25.63,20c-3.88,2.99-2.72,6.38,2.62,7.54c14.4,3.14,21.59,4.7,35.92,7.8 c5.31,1.15,12.83-0.44,16.77-3.52c10.62-8.32,15.85-12.44,26.01-20.57C1662.68,1438.02,1661.34,1434.74,1655.97,1433.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 664.235,
    x2: 2011.849,
    y1: 1411.215,
    y2: 1476.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M1732.05,1448.6c-14.28-2.77-21.45-4.16-35.84-6.98c-5.33-1.04-12.68,0.55-16.46,3.59 c-10.21,8.21-15.47,12.38-26.15,20.78c-3.96,3.12-2.91,6.58,2.36,7.7c14.23,3.05,21.32,4.56,35.45,7.55 c5.23,1.11,12.76-0.61,16.78-3.81c10.84-8.64,16.18-12.93,26.54-21.35C1738.56,1452.96,1737.34,1449.62,1732.05,1448.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 630.252,
    x2: 1972.813,
    y1: 1420.96,
    y2: 1486.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M1730.59,1489.5c13.98,2.93,20.94,4.38,34.77,7.24c5.13,1.06,12.63-0.8,16.74-4.12 c11.07-8.97,16.52-13.41,27.09-22.14c3.91-3.23,2.84-6.61-2.34-7.59c-13.99-2.64-21.03-3.97-35.17-6.67 c-5.24-1-12.58,0.71-16.44,3.87c-10.41,8.51-15.78,12.83-26.69,21.57C1724.51,1484.89,1725.41,1488.41,1730.59,1489.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 599.414,
    x2: 1932.712,
    y1: 1430.217,
    y2: 1495.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M1879.92,1476.43c-13.63-2.48-20.5-3.74-34.31-6.3c-5.12-0.95-12.42,0.89-16.36,4.16 c-10.62,8.8-16.1,13.29-27.24,22.35c-4.13,3.36-3.39,6.94,1.66,7.97c13.65,2.78,20.43,4.16,33.9,6.87c4.99,1,12.45-1,16.65-4.45 c11.31-9.3,16.88-13.9,27.65-22.92C1885.87,1480.77,1884.98,1477.35,1879.92,1476.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 917.692,
    x2: 2176.786,
    y1: 1355.674,
    y2: 1417.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M1075.7,1353.72c-13.51-3.22-20.22-4.83-33.54-8.01c-4.94-1.18-11.76-0.33-15.3,1.89 c-9.53,6-14.35,9-24.06,15.08c-3.6,2.25-2.57,5.1,2.33,6.36c13.24,3.38,19.9,5.09,33.32,8.52c4.97,1.27,11.98,0.41,15.61-1.92 c9.79-6.28,14.66-9.39,24.28-15.59C1081.91,1357.75,1080.7,1354.91,1075.7,1353.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 878.96,
    x2: 2164.946,
    y1: 1367.995,
    y2: 1430.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M1148.11,1370.96c-13.86-3.29-20.76-4.93-34.46-8.2c-5.08-1.21-12.06-0.3-15.64,2.02 c-9.66,6.28-14.54,9.43-24.37,15.79c-3.64,2.36-2.54,5.32,2.51,6.61c13.61,3.48,20.45,5.22,34.21,8.73 c5.1,1.3,12.24,0.37,15.92-2.06c9.93-6.57,14.87-9.83,24.63-16.33C1154.5,1375.12,1153.24,1372.18,1148.11,1370.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 838.388,
    x2: 2147.582,
    y1: 1380.497,
    y2: 1444.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M1222.14,1388.5c-14.13-3.34-21.17-5-35.18-8.32c-5.19-1.23-12.32-0.26-15.95,2.18 c-9.8,6.58-14.76,9.88-24.73,16.53c-3.69,2.47-2.54,5.54,2.62,6.85c13.9,3.54,20.88,5.32,34.89,8.88 c5.19,1.32,12.45,0.32,16.19-2.23c10.08-6.88,15.1-10.29,25.02-17.09C1228.67,1392.78,1227.38,1389.74,1222.14,1388.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 796.5,
    x2: 2125.177,
    y1: 1393.092,
    y2: 1457.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M1223,1424.58c14.11,3.58,21.19,5.37,35.38,8.96c5.26,1.33,12.61,0.24,16.41-2.43 c10.25-7.19,15.36-10.77,25.45-17.89c3.74-2.64,2.45-5.78-2.86-7.02c-14.32-3.36-21.46-5.03-35.7-8.38 c-5.28-1.24-12.52-0.18-16.22,2.37c-9.97,6.89-15.01,10.34-25.14,17.31C1216.59,1420.08,1217.77,1423.25,1223,1424.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 753.866,
    x2: 2098.185,
    y1: 1405.693,
    y2: 1471.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M1298.03,1443.55c14.25,3.59,21.39,5.39,35.68,8.98c5.29,1.33,12.73,0.14,16.6-2.64 c10.43-7.52,15.64-11.26,25.92-18.7c3.81-2.76,2.55-5.99-2.8-7.23c-14.43-3.35-21.63-5.03-36.02-8.38 c-5.33-1.24-12.67-0.09-16.44,2.57c-10.15,7.2-15.28,10.83-25.58,18.11C1291.57,1438.95,1292.75,1442.22,1298.03,1443.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 711.071,
    x2: 2067.114,
    y1: 1418.213,
    y2: 1484.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M1373.56,1462.52c14.31,3.58,21.46,5.37,35.77,8.93c5.3,1.32,12.8,0.02,16.73-2.88 c10.63-7.85,15.94-11.76,26.43-19.54c3.89-2.88,2.68-6.2-2.68-7.43c-14.46-3.32-21.69-4.99-36.14-8.32 c-5.36-1.24-12.78,0.01-16.62,2.81c-10.34,7.53-15.57,11.32-26.06,18.93C1367.12,1457.83,1368.26,1461.2,1373.56,1462.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 668.687,
    x2: 2032.528,
    y1: 1430.565,
    y2: 1497.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M1526.16,1459.01c-14.41-3.26-21.62-4.9-36.06-8.2c-5.35-1.22-12.84,0.14-16.75,3.06 c-10.55,7.87-15.88,11.82-26.57,19.77c-3.96,2.94-2.88,6.4,2.41,7.71c14.29,3.54,21.42,5.3,35.67,8.81 c5.28,1.3,12.82-0.11,16.83-3.15c10.84-8.19,16.26-12.27,26.96-20.38C1532.63,1463.63,1531.5,1460.22,1526.16,1459.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 627.349,
    x2: 1994.966,
    y1: 1442.666,
    y2: 1509.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M1602.03,1476.07c-14.28-3.18-21.43-4.79-35.78-8.01c-5.32-1.19-12.85,0.29-16.84,3.33 c-10.77,8.21-16.21,12.34-27.11,20.62c-4.04,3.07-3.05,6.61,2.21,7.89c14.19,3.47,21.27,5.2,35.38,8.63 c5.23,1.27,12.78-0.27,16.88-3.43c11.06-8.53,16.59-12.79,27.52-21.24C1608.34,1480.73,1607.32,1477.25,1602.03,1476.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 587.648,
    x2: 1955.022,
    y1: 1454.428,
    y2: 1521.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M1677,1492.63c-14.07-3.08-21.13-4.63-35.31-7.76c-5.25-1.16-12.8,0.45-16.88,3.62 c-10.99,8.55-16.56,12.85-27.67,21.48c-4.12,3.2-3.24,6.81,1.95,8.06c14.01,3.38,20.99,5.06,34.88,8.39 c5.15,1.23,12.7-0.44,16.88-3.73c11.28-8.87,16.93-13.3,28.1-22.1C1683.09,1497.32,1682.21,1493.77,1677,1492.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 785.106,
    x2: 1861.533,
    y1: 1483.728,
    y2: 1536.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M1822.54,1523.75c-28.36-5.9-42.76-8.95-71.9-15.18c-3.19-0.68-4.79-1.02-7.99-1.71 c-10.61-2.28-15.94-3.42-26.64-5.74c-5.16-1.12-12.71,0.63-16.87,3.93c-11.23,8.89-16.91,13.37-28.26,22.34 c-4.2,3.32-3.47,7,1.62,8.21c10.57,2.51,15.83,3.75,26.31,6.22c3.16,0.74,4.74,1.11,7.88,1.85c28.77,6.76,42.99,10.07,70.97,16.5 c4.9,1.13,12.39-0.84,16.74-4.38c11.76-9.56,17.65-14.34,29.3-23.82C1828.04,1528.45,1827.51,1524.78,1822.54,1523.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 861.357,
    x2: 2128.03,
    y1: 1387.691,
    y2: 1449.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M1025.55,1385.83c-13.39-3.5-20.05-5.24-33.26-8.69c-4.9-1.28-11.8-0.45-15.44,1.86 c-9.85,6.23-14.81,9.39-24.74,15.84c-3.68,2.39-2.74,5.43,2.14,6.78c13.16,3.63,19.79,5.45,33.12,9.13 c4.94,1.36,11.96,0.47,15.66-1.98c9.98-6.61,14.96-9.86,24.88-16.28C1031.58,1390.09,1030.51,1387.12,1025.55,1385.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 821.937,
    x2: 2112.111,
    y1: 1401.412,
    y2: 1464.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M1097.27,1404.56c-13.72-3.58-20.55-5.36-34.13-8.91c-5.03-1.31-12.07-0.44-15.76,1.97 c-9.94,6.5-14.94,9.78-24.94,16.46c-3.7,2.47-2.66,5.62,2.34,7c13.51,3.73,20.31,5.61,33.96,9.38c5.06,1.4,12.19,0.46,15.91-2.08 c10.05-6.85,15.08-10.23,25.11-16.93C1103.48,1408.96,1102.36,1405.89,1097.27,1404.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 781.135,
    x2: 2091.239,
    y1: 1415.411,
    y2: 1479.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M1170.54,1423.65c-13.98-3.64-20.94-5.45-34.8-9.06c-5.14-1.34-12.31-0.4-16.04,2.11 c-10.06,6.78-15.11,10.19-25.18,17.11c-3.73,2.57-2.62,5.8,2.49,7.21c13.79,3.81,20.71,5.72,34.6,9.56 c5.15,1.42,12.37,0.43,16.12-2.2c10.14-7.11,15.23-10.63,25.39-17.61C1176.87,1428.19,1175.71,1425,1170.54,1423.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 739.469,
    x2: 2065.846,
    y1: 1429.59,
    y2: 1494.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M1170.46,1461.32c13.98,3.86,21,5.8,35.05,9.67c5.21,1.44,12.5,0.38,16.3-2.36 c10.24-7.37,15.4-11.04,25.7-18.32c3.82-2.7,2.65-5.98-2.59-7.34c-14.15-3.67-21.21-5.5-35.28-9.15 c-5.22-1.35-12.5-0.34-16.28,2.28c-10.19,7.07-15.3,10.62-25.47,17.8C1164.13,1456.56,1165.28,1459.89,1170.46,1461.32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 697.473,
    x2: 2036.414,
    y1: 1443.849,
    y2: 1509.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M1244.76,1481.8c14.11,3.88,21.17,5.82,35.31,9.71c5.24,1.44,12.59,0.3,16.43-2.53 c10.36-7.65,15.6-11.46,26.06-19.05c3.88-2.81,2.74-6.19-2.54-7.55c-14.24-3.67-21.36-5.5-35.57-9.18 c-5.26-1.36-12.63-0.26-16.47,2.47c-10.34,7.37-15.52,11.07-25.8,18.52C1238.38,1476.95,1239.54,1480.36,1244.76,1481.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 655.74,
    x2: 2003.4,
    y1: 1458.093,
    y2: 1523.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M1319.51,1502.33c14.15,3.88,21.23,5.81,35.37,9.67c5.24,1.43,12.62,0.21,16.51-2.73 c10.5-7.93,15.81-11.89,26.45-19.8c3.94-2.93,2.86-6.39-2.43-7.74c-14.26-3.64-21.39-5.47-35.66-9.13 c-5.28-1.36-12.73-0.16-16.62,2.69c-10.51,7.68-15.76,11.53-26.16,19.25C1313.12,1497.4,1314.26,1500.89,1319.51,1502.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 614.822,
    x2: 1967.361,
    y1: 1472.223,
    y2: 1538.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M1470.68,1500.87c-14.2-3.59-21.31-5.4-35.55-9.02c-5.28-1.34-12.77-0.03-16.73,2.93 c-10.68,7.99-16.02,12-26.56,20.01c-3.91,2.97-2.81,6.53,2.43,7.95c14.12,3.84,21.17,5.76,35.24,9.57 c5.22,1.41,12.61,0.09,16.56-2.95c10.65-8.22,16.05-12.34,26.86-20.56C1476.95,1505.75,1475.95,1502.2,1470.68,1500.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 575.332,
    x2: 1928.83,
    y1: 1486.144,
    y2: 1552.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M1545.43,1519.68c-14.06-3.52-21.11-5.28-35.25-8.84c-5.24-1.32-12.76,0.11-16.79,3.19 c-10.87,8.31-16.29,12.47-26.98,20.77c-3.96,3.08-2.93,6.7,2.26,8.1c14.01,3.78,21,5.66,34.92,9.4 c5.16,1.39,12.56-0.04,16.56-3.2c10.8-8.51,16.29-12.79,27.3-21.33C1551.54,1524.6,1550.64,1520.98,1545.43,1519.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 537.891,
    x2: 1888.367,
    y1: 1499.762,
    y2: 1565.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M1619.23,1538c-13.84-3.41-20.79-5.13-34.75-8.59c-5.17-1.28-12.71,0.27-16.81,3.47 c-11.07,8.64-16.58,12.96-27.43,21.55c-4.02,3.18-3.09,6.87,2.03,8.24c13.82,3.69,20.71,5.52,34.41,9.16 c5.08,1.35,12.45-0.2,16.51-3.46c10.97-8.8,16.55-13.24,27.77-22.11C1625.13,1542.95,1624.36,1539.26,1619.23,1538z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 503.099,
    x2: 1846.563,
    y1: 1512.98,
    y2: 1578.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M1691.67,1555.7c-13.55-3.28-20.36-4.94-34.05-8.28c-5.07-1.24-12.6,0.45-16.78,3.77 c-11.27,8.96-16.88,13.44-27.9,22.32c-4.08,3.29-3.27,7.03,1.75,8.35c13.56,3.57,20.3,5.34,33.7,8.84 c4.97,1.3,12.29-0.37,16.42-3.74c11.14-9.1,16.82-13.69,28.25-22.88C1697.3,1560.66,1696.7,1556.92,1691.67,1555.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 471.525,
    x2: 1804.013,
    y1: 1525.703,
    y2: 1590.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M1762.35,1572.63c-13.17-3.12-19.81-4.7-33.17-7.9c-4.95-1.19-12.45,0.64-16.7,4.08 c-11.48,9.29-17.19,13.92-28.38,23.1c-4.15,3.4-3.48,7.18,1.41,8.44c13.22,3.42,19.78,5.12,32.81,8.46 c4.83,1.24,12.08-0.57,16.28-4.04c11.32-9.39,17.1-14.13,28.74-23.66C1767.65,1577.59,1767.23,1573.79,1762.35,1572.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 804.972,
    x2: 2071.628,
    y1: 1421.829,
    y2: 1483.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M974.29,1419.53c-13.33-3.73-19.95-5.58-33.1-9.26c-4.87-1.36-11.8-0.46-15.5,2.03 c-9.98,6.74-14.97,10.18-24.94,17.26c-3.69,2.62-2.74,5.92,2.15,7.32c13.18,3.78,19.82,5.69,33.17,9.53 c4.95,1.42,11.94,0.4,15.62-2.25c9.92-7.17,14.9-10.66,24.88-17.53C980.25,1424.08,979.22,1420.92,974.29,1419.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 766.532,
    x2: 2050.135,
    y1: 1436.667,
    y2: 1499.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M1045.62,1439.53c-13.64-3.83-20.43-5.73-33.93-9.52c-5-1.4-12.05-0.48-15.74,2.08 c-9.98,6.92-14.96,10.44-24.86,17.64c-3.67,2.67-2.59,6.02,2.42,7.47c13.52,3.9,20.31,5.86,33.96,9.81 c5.06,1.46,12.12,0.44,15.77-2.26c9.86-7.29,14.84-10.87,24.83-17.93C1051.77,1444.21,1050.67,1440.95,1045.62,1439.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 727.697,
    x2: 2024.785,
    y1: 1451.907,
    y2: 1515.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M1118.38,1459.97c-13.87-3.9-20.79-5.84-34.56-9.7c-5.1-1.43-12.24-0.47-15.95,2.16 c-10,7.11-14.98,10.72-24.83,18.05c-3.65,2.72-2.47,6.13,2.64,7.61c13.77,3.99,20.69,6,34.56,10.02 c5.14,1.49,12.24,0.45,15.88-2.3c9.83-7.43,14.81-11.1,24.83-18.36C1124.68,1464.75,1123.52,1461.41,1118.38,1459.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 793.991,
    x2: 1774.414,
    y1: 1499.411,
    y2: 1547.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M1415.79,1543.01c-13.4-3.7-20.12-5.56-33.55-9.29c-0.65-0.18-0.97-0.27-1.61-0.45 c-15.71-4.36-23.58-6.54-39.32-10.92c-14.12-3.93-21.18-5.9-35.31-9.84c-15.75-4.39-23.63-6.59-39.36-10.99 c-14.11-3.95-21.16-5.92-35.25-9.86c-29.79-8.34-44.65-12.51-74.19-20.8c-5.18-1.45-12.39-0.44-16.11,2.27 c-10.03,7.32-15.02,11.01-24.84,18.49c-3.64,2.77-2.38,6.24,2.79,7.74c29.52,8.57,44.37,12.89,74.11,21.52 c14.06,4.08,21.1,6.13,35.19,10.21c15.71,4.56,23.57,6.84,39.28,11.39c14.09,4.08,21.14,6.12,35.22,10.2 c15.7,4.54,23.55,6.81,39.21,11.33c0.64,0.19,0.97,0.28,1.61,0.46c13.4,3.87,20.1,5.8,33.46,9.64 c5.19,1.49,12.29,0.29,15.94-2.71c9.83-8.08,14.89-12.15,25.2-20.32C1422.07,1548.08,1420.99,1544.45,1415.79,1543.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 546.204,
    x2: 1855.625,
    y1: 1530.318,
    y2: 1594.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M1489.69,1563.35c-13.9-3.81-20.87-5.72-34.84-9.57c-5.18-1.42-12.52-0.1-16.35,2.95 c-10.33,8.23-15.4,12.33-25.24,20.46c-3.65,3.01-2.36,6.65,2.8,8.13c13.93,4,20.87,5.99,34.72,9.95 c5.13,1.47,12.19,0.19,15.84-2.87c9.86-8.26,14.96-12.44,25.36-20.84C1495.84,1568.44,1494.84,1564.76,1489.69,1563.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 516.539,
    x2: 1816.836,
    y1: 1545.697,
    y2: 1609.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M1562.61,1583.22c-13.67-3.7-20.54-5.57-34.33-9.32c-5.11-1.39-12.44,0.03-16.3,3.17 c-10.43,8.47-15.54,12.68-25.41,20.99c-3.66,3.08-2.43,6.73,2.66,8.18c13.74,3.91,20.57,5.85,34.19,9.71 c5.04,1.43,12.03,0.07,15.7-3.05c9.9-8.43,15.04-12.72,25.55-21.37C1568.56,1588.31,1567.67,1584.59,1562.61,1583.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 490.529,
    x2: 1777.707,
    y1: 1560.731,
    y2: 1623.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M1634.13,1602.46c-13.37-3.57-20.1-5.37-33.62-9.01c-5.01-1.35-12.3,0.19-16.21,3.42 c-10.54,8.72-15.69,13.03-25.6,21.52c-3.67,3.14-2.52,6.81,2.47,8.22c13.46,3.79,20.16,5.67,33.47,9.39 c4.93,1.38,11.83-0.07,15.51-3.26c9.94-8.61,15.13-13.01,25.75-21.9C1639.84,1607.54,1639.09,1603.78,1634.13,1602.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 468.769,
    x2: 1738.841,
    y1: 1575.314,
    y2: 1637.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M1703.86,1620.92c-12.99-3.41-19.54-5.14-32.71-8.62c-4.88-1.29-12.11,0.36-16.06,3.68 c-10.66,8.96-15.85,13.38-25.81,22.04c-3.69,3.21-2.65,6.88,2.21,8.23c13.12,3.64,19.63,5.44,32.56,9 c4.79,1.32,11.58-0.22,15.28-3.48c9.99-8.79,15.22-13.29,25.97-22.42C1709.27,1625.97,1708.67,1622.19,1703.86,1620.92z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1400.21,
    cy: 1459.82,
    fill: "#00114c",
    opacity: 0,
    rx: 128.56,
    ry: 449.45,
    transform: "rotate(-81.958 1400.202 1459.773)",
    className: "color4c0000 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1402.74,
    cy: 1459.22,
    fill: "#01124a",
    opacity: 0.038,
    rx: 124.94,
    ry: 436.82,
    transform: "rotate(-81.958 1402.731 1459.175)",
    className: "color4a0101 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1405.27,
    cy: 1458.62,
    fill: "#021248",
    opacity: 0.077,
    rx: 121.33,
    ry: 424.19,
    transform: "rotate(-81.958 1405.26 1458.576)",
    className: "color480202 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1407.8,
    cy: 1458.02,
    fill: "#031246",
    opacity: 0.115,
    rx: 117.72,
    ry: 411.56,
    transform: "rotate(-81.958 1407.79 1457.977)",
    className: "color460303 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1410.33,
    cy: 1457.42,
    fill: "#041344",
    opacity: 0.154,
    rx: 114.11,
    ry: 398.94,
    transform: "rotate(-81.958 1410.32 1457.378)",
    className: "color440404 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1412.86,
    cy: 1456.83,
    fill: "#051342",
    opacity: 0.192,
    rx: 110.5,
    ry: 386.31,
    transform: "rotate(-81.958 1412.848 1456.78)",
    className: "color420505 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1415.39,
    cy: 1456.23,
    fill: "#061340",
    opacity: 0.231,
    rx: 106.88,
    ry: 373.68,
    transform: "rotate(-81.958 1415.378 1456.18)",
    className: "color400606 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1417.92,
    cy: 1455.63,
    fill: "#06133e",
    opacity: 0.269,
    rx: 103.27,
    ry: 361.05,
    transform: "rotate(-81.958 1417.907 1455.582)",
    className: "color3e0606 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1420.45,
    cy: 1455.03,
    fill: "#07133c",
    opacity: 0.308,
    rx: 99.66,
    ry: 348.43,
    transform: "rotate(-81.958 1420.436 1454.983)",
    className: "color3c0707 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1422.98,
    cy: 1454.43,
    fill: "#08133a",
    opacity: 0.346,
    rx: 96.05,
    ry: 335.8,
    transform: "rotate(-81.958 1422.965 1454.384)",
    className: "color3a0808 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1425.51,
    cy: 1453.83,
    fill: "#091438",
    opacity: 0.385,
    rx: 92.44,
    ry: 323.17,
    transform: "rotate(-81.958 1425.495 1453.785)",
    className: "color380909 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1428.04,
    cy: 1453.23,
    fill: "#0a1436",
    opacity: 0.423,
    rx: 88.82,
    ry: 310.54,
    transform: "rotate(-81.958 1428.024 1453.186)",
    className: "color360a0a svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1430.57,
    cy: 1452.63,
    fill: "#0b1434",
    opacity: 0.462,
    rx: 85.21,
    ry: 297.92,
    transform: "rotate(-81.958 1430.553 1452.588)",
    className: "color340b0b svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1433.09,
    cy: 1452.04,
    fill: "#0c1533",
    opacity: 0.5,
    rx: 81.6,
    ry: 285.29,
    transform: "rotate(-81.958 1433.082 1451.989)",
    className: "color330c0c svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1435.62,
    cy: 1451.44,
    fill: "#0d1531",
    opacity: 0.538,
    rx: 77.99,
    ry: 272.66,
    transform: "rotate(-81.958 1435.611 1451.39)",
    className: "color310d0d svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1438.15,
    cy: 1450.84,
    fill: "#0e162f",
    opacity: 0.577,
    rx: 74.38,
    ry: 260.04,
    transform: "rotate(-81.958 1438.14 1450.791)",
    className: "color2f0e0e svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1440.68,
    cy: 1450.24,
    fill: "#0f162d",
    opacity: 0.615,
    rx: 70.77,
    ry: 247.41,
    transform: "rotate(-81.958 1440.67 1450.192)",
    className: "color2d0f0f svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1443.21,
    cy: 1449.64,
    fill: "#10162b",
    opacity: 0.654,
    rx: 67.15,
    ry: 234.78,
    transform: "rotate(-81.958 1443.199 1449.593)",
    className: "color2b1010 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1445.74,
    cy: 1449.04,
    fill: "#111729",
    opacity: 0.692,
    rx: 63.54,
    ry: 222.15,
    transform: "rotate(-81.958 1445.728 1448.995)",
    className: "color291111 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1448.27,
    cy: 1448.44,
    fill: "#121727",
    opacity: 0.731,
    rx: 59.93,
    ry: 209.53,
    transform: "rotate(-81.958 1448.257 1448.396)",
    className: "color271212 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1450.8,
    cy: 1447.84,
    fill: "#121625",
    opacity: 0.769,
    rx: 56.32,
    ry: 196.9,
    transform: "rotate(-81.958 1450.786 1447.797)",
    className: "color251212 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1453.33,
    cy: 1447.25,
    fill: "#131723",
    opacity: 0.808,
    rx: 52.71,
    ry: 184.27,
    transform: "rotate(-81.958 1453.315 1447.198)",
    className: "color231313 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1455.86,
    cy: 1446.65,
    fill: "#141721",
    opacity: 0.846,
    rx: 49.09,
    ry: 171.64,
    transform: "rotate(-81.958 1455.844 1446.6)",
    className: "color211414 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1458.39,
    cy: 1446.05,
    fill: "#15171f",
    opacity: 0.885,
    rx: 45.48,
    ry: 159.02,
    transform: "rotate(-81.958 1458.373 1446)",
    className: "color1f1515 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1460.92,
    cy: 1445.45,
    fill: "#16181d",
    opacity: 0.923,
    rx: 41.87,
    ry: 146.39,
    transform: "rotate(-81.958 1460.901 1445.402)",
    className: "color1d1616 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1463.45,
    cy: 1444.85,
    fill: "#17181b",
    opacity: 0.962,
    rx: 38.26,
    ry: 133.76,
    transform: "rotate(-81.958 1463.43 1444.803)",
    className: "color1b1717 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1465.98,
    cy: 1444.25,
    fill: "#181819",
    rx: 34.65,
    ry: 121.13,
    transform: "rotate(-81.958 1465.958 1444.204)",
    className: "color191818 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 797.919,
    x2: 1952.77,
    y1: 1054.884,
    y2: 1100.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M1964.96,781.09l-141.85,707.94c-4.97,26.43-30.88,42.92-57.32,36.64l-931.97-220.36 c-4.71-1.05-9.16-2.62-13.35-5.5c-6.28-3.4-11.78-7.59-15.96-12.82c-12.3-13.61-17.53-32.98-12.3-51.56l154.67-579.7 c4.71-17.53,20.94-28.27,38.47-26.43l941.66,99.98c13.35,1.31,24.6,9.16,31.14,19.63c0.78,1.05,1.57,2.36,2.36,3.66 C1965.22,761.2,1967.05,771.15,1964.96,781.09z",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 804.503,
    x2: 1972.615,
    y1: 1144.892,
    y2: 1144.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M1971.76,791.04l-141.59,708.21c-5.23,26.43-31.14,42.92-57.32,36.64l-932.23-220.36 c-4.71-1.31-8.9-2.88-13.09-5.5c-9.95-5.23-17.8-13.35-23.03-23.03c4.19,5.23,9.68,9.42,15.96,12.82 c4.19,2.88,8.64,4.45,13.35,5.5l931.97,220.36c26.43,6.28,52.34-10.21,57.32-36.64l141.85-707.94 c2.09-9.95,0.26-19.89-4.45-28.53c1.83,2.09,3.4,4.19,4.71,6.28C1971.5,768.01,1974.11,779.78,1971.76,791.04z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f1f1f2",
    strokeMiterlimit: 10,
    strokeWidth: 3.007,
    d: "M1757.42,1456.45c-301.19-64.63-602.51-129.35-901.01-208.09c58.39-230.28,87.47-323.02,144.55-554.11 c295.95,36.21,591.81,73.54,887.8,109.18C1842.71,1035.63,1803.47,1224.25,1757.42,1456.45z",
    className: "colorStrokef1f1f2 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1864.83 923.19c-297.36-38.02-594.57-77.87-891.64-119.11 4.47-17.3 6.7-26 11.15-43.54 296.74 38.54 593.51 76.69 890.43 113.07C1870.88 893.07 1868.89 903.01 1864.83 923.19zM1845.25 1020.34c-297.94-42.9-595.71-87.66-893.07-135.77 4.48-17.01 6.72-25.53 11.2-42.68 297.26 44.21 594.75 86.12 892.42 126.18C1851.63 988.76 1849.51 999.24 1845.25 1020.34zM1825.01 1120.46c-298.36-49.15-596.53-100.02-893.92-156.37 4.5-16.89 6.75-25.34 11.24-42.27 297.41 51.87 595.36 99.41 893.51 145.13C1831.52 1088.29 1829.35 1099.02 1825.01 1120.46zM1804.71 1220.84c-298.79-55.6-597.43-112.58-894.79-177.35 4.51-16.95 6.77-25.41 11.28-42.3 297.37 60.34 595.74 114.13 894.29 166.35C1811.15 1188.94 1808.99 1199.63 1804.71 1220.84zM1784.95 1318.76c-299.43-61.05-598.8-122.97-896.26-195.14 4.53-17.2 6.79-25.75 11.31-42.8 297.37 68.43 596.31 127.93 895.36 186.28C1791.15 1288 1789.06 1298.36 1784.95 1318.76zM1766.36 1411.5c-300.45-64.27-600.97-128.85-898.95-206.19 4.54-17.62 6.81-26.36 11.34-43.73 297.64 74.94 597.49 138.46 897.33 201.37C1772.1 1382.76 1770.15 1392.5 1766.36 1411.5z",
    opacity: 0.56,
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f1f1f2",
    strokeMiterlimit: 10,
    strokeWidth: 3.007,
    d: "M1352.55 737.59c-53.82 233.56-87.46 365.2-142.08 598.27M1062.84 701.8c-57.39 231.77-87.7 331.38-146.31 562.39M1530.14 759.62c-49.8 233.67-84.6 384.63-134.93 617.97M1708.69 781.6c-46.6 233.17-82.98 403.14-129.84 636.15",
    className: "colorStrokef1f1f2 svgStroke"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1275.47 754.93c-78.68-9.82-118.12-14.76-197.93-24.68-1.29-.16-2.09-1.31-1.78-2.56l0 0c.31-1.25 1.62-2.14 2.92-1.98 79.8 9.89 119.23 14.81 197.89 24.61 1.27.16 2.07 1.33 1.77 2.59l0 0C1278.03 754.18 1276.75 755.09 1275.47 754.93zM1272.16 768.78c-78.76-9.91-118.23-14.89-198.02-24.92-1.29-.16-2.09-1.31-1.78-2.56l0 0c.31-1.25 1.62-2.13 2.92-1.97 79.8 9.99 119.26 14.96 197.99 24.83 1.27.16 2.07 1.33 1.76 2.6l0 0C1274.73 768.03 1273.44 768.94 1272.16 768.78zM1228.17 777.47c-62.7-7.97-94.13-11.98-157.48-20.06-1.27-.16-2.06-1.3-1.75-2.52.01-.02.01-.03.01-.06.31-1.23 1.61-2.1 2.88-1.94 63.36 8.03 94.78 12.03 157.47 19.97 1.26.16 2.04 1.31 1.74 2.56 0 .02-.01.04-.01.06C1230.72 776.74 1229.44 777.63 1228.17 777.47z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1261.09 814.8c-78.98-10.36-118.53-15.58-198.29-26.14-1.29-.17-2.09-1.32-1.77-2.55l0 0c.31-1.23 1.63-2.11 2.92-1.94 79.77 10.5 119.31 15.69 198.27 25.99 1.28.17 2.07 1.35 1.76 2.62l0 0C1263.66 814.06 1262.37 814.96 1261.09 814.8zM1196.77 820.58c-54.79-7.33-82.24-11.03-137.41-18.48-1.29-.17-2.09-1.32-1.77-2.55l0 0c.32-1.23 1.63-2.1 2.92-1.92 55.17 7.4 82.62 11.07 137.4 18.36 1.28.17 2.07 1.34 1.76 2.61l0 0C1199.35 819.86 1198.05 820.75 1196.77 820.58z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1250.2 859.62c-79.16-11-118.78-16.56-198.47-27.85-1.29-.18-2.08-1.33-1.77-2.56l0 0c.32-1.23 1.63-2.08 2.92-1.9 79.69 11.2 119.31 16.72 198.45 27.65 1.28.18 2.07 1.37 1.76 2.65l0 0C1252.78 858.89 1251.48 859.8 1250.2 859.62zM1185.73 864.9c-54.87-7.84-82.34-11.79-137.45-19.78-1.29-.19-2.08-1.34-1.77-2.56l0 0c.32-1.22 1.63-2.07 2.92-1.89 55.12 7.93 82.58 11.85 137.44 19.63 1.28.18 2.07 1.37 1.76 2.63l0 0C1188.32 864.2 1187.01 865.08 1185.73 864.9z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1239.2 904.57c-79.32-11.81-118.99-17.79-198.58-29.97-1.29-.2-2.08-1.35-1.76-2.57l0 0c.32-1.22 1.63-2.05 2.92-1.86 79.6 12.08 119.27 18.01 198.57 29.73 1.28.19 2.07 1.4 1.76 2.68l0 0C1241.79 903.87 1240.48 904.77 1239.2 904.57zM1174.6 909.23c-54.93-8.44-82.41-12.71-137.45-21.34-1.29-.2-2.08-1.36-1.76-2.58l0 0c.32-1.22 1.63-2.05 2.92-1.85 55.05 8.56 82.53 12.79 137.45 21.17 1.28.2 2.07 1.39 1.76 2.66l0 0C1177.2 908.55 1175.89 909.42 1174.6 909.23z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1229.33 944.67c-79.44-12.63-119.15-19.04-198.63-32.11-1.29-.21-2.08-1.38-1.76-2.59l0 0c.32-1.21 1.63-2.03 2.92-1.83 79.5 12.96 119.2 19.32 198.63 31.85 1.29.2 2.08 1.42 1.76 2.71l0 0C1231.92 943.99 1230.61 944.87 1229.33 944.67zM1164.64 948.68c-54.98-9.04-82.46-13.62-137.42-22.88-1.29-.22-2.08-1.39-1.76-2.6l0 0c.32-1.21 1.63-2.03 2.92-1.81 54.97 9.19 82.46 13.73 137.43 22.7 1.28.21 2.07 1.42 1.75 2.68l0 0C1167.24 948.03 1165.93 948.89 1164.64 948.68z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1218.27 989.45c-79.56-13.62-119.31-20.54-198.67-34.68-1.28-.23-2.07-1.41-1.75-2.62l0 0c.32-1.21 1.63-2.01 2.92-1.79 79.37 14.03 119.12 20.89 198.67 34.41 1.29.22 2.08 1.45 1.76 2.74l0 0C1220.87 988.79 1219.55 989.67 1218.27 989.45zM1153.49 992.68c-55.02-9.75-82.51-14.69-137.38-24.71-1.28-.23-2.07-1.42-1.75-2.63l0 0c.32-1.21 1.63-2.01 2.91-1.78 54.88 9.94 82.37 14.84 137.39 24.52 1.29.23 2.08 1.45 1.76 2.71l0 0C1156.09 992.06 1154.78 992.91 1153.49 992.68z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1207.17 1034.24c-79.68-14.65-119.47-22.1-198.7-37.34-1.28-.25-2.07-1.44-1.75-2.65l0 0c.32-1.21 1.63-2 2.91-1.75 79.24 15.13 119.03 22.52 198.7 37.06 1.29.24 2.08 1.48 1.76 2.77l0 0C1209.77 1033.62 1208.46 1034.48 1207.17 1034.24zM1142.32 1036.68c-55.07-10.48-82.55-15.79-137.34-26.57-1.28-.25-2.07-1.45-1.75-2.66l0 0c.32-1.21 1.63-1.99 2.91-1.74 54.79 10.71 82.28 15.98 137.34 26.38 1.29.24 2.08 1.48 1.76 2.74l0 0C1144.92 1036.09 1143.61 1036.92 1142.32 1036.68z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1196.07 1079.03c-79.81-15.67-119.64-23.64-198.74-39.98-1.28-.26-2.06-1.47-1.74-2.68l0 0c.32-1.21 1.63-1.99 2.91-1.72 79.11 16.23 118.94 24.15 198.73 39.71 1.29.25 2.09 1.51 1.77 2.8l0 0C1198.67 1078.43 1197.36 1079.28 1196.07 1079.03zM1131.14 1080.67c-55.12-11.19-82.61-16.86-137.31-28.4-1.28-.27-2.06-1.48-1.74-2.69l0 0c.32-1.21 1.63-1.98 2.91-1.71 54.71 11.46 82.2 17.09 137.31 28.21 1.29.26 2.08 1.51 1.76 2.77l0 0C1133.75 1080.11 1132.43 1080.93 1131.14 1080.67z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1186.4 1118.04c-79.93-16.51-119.79-24.92-198.79-42.17-1.28-.28-2.06-1.5-1.74-2.71l0 0c.32-1.21 1.63-1.98 2.9-1.7 79.01 17.15 118.87 25.51 198.79 41.92 1.29.27 2.09 1.53 1.77 2.82l0 0C1189.01 1117.47 1187.69 1118.3 1186.4 1118.04zM1121.41 1119.01c-55.16-11.77-82.66-17.75-137.3-29.9-1.28-.28-2.06-1.51-1.74-2.72l0 0c.32-1.21 1.63-1.98 2.9-1.69 54.64 12.08 82.14 18.02 137.3 29.72 1.29.27 2.08 1.53 1.76 2.8l0 0C1124.02 1118.48 1122.7 1119.29 1121.41 1119.01z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1175.04 1163.97c-80.08-17.41-120-26.3-198.9-44.53-1.28-.3-2.06-1.53-1.74-2.75l0 0c.32-1.22 1.62-1.97 2.9-1.68 78.91 18.14 118.82 26.98 198.89 44.31 1.3.28 2.1 1.56 1.78 2.84l0 0C1177.65 1163.43 1176.34 1164.25 1175.04 1163.97zM1109.97 1164.23c-55.24-12.39-82.75-18.68-137.32-31.49-1.28-.3-2.06-1.54-1.74-2.76l0 0c.32-1.22 1.62-1.97 2.9-1.68 54.57 12.74 82.08 19 137.31 31.34 1.29.29 2.09 1.56 1.77 2.82l0 0C1112.57 1163.73 1111.26 1164.52 1109.97 1164.23z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1165.67 1201.97c-80.23-18.06-120.2-27.28-199.04-46.23-1.28-.31-2.06-1.56-1.74-2.78l0 0c.32-1.22 1.62-1.98 2.9-1.67 78.84 18.87 118.8 28.05 199.02 46.03 1.3.29 2.1 1.58 1.79 2.85l0 0C1168.29 1201.45 1166.97 1202.26 1165.67 1201.97zM1100.52 1201.72c-55.31-12.82-82.84-19.33-137.37-32.6-1.28-.31-2.06-1.57-1.74-2.8l0 0c.32-1.23 1.62-1.98 2.9-1.67 54.53 13.22 82.06 19.7 137.36 32.47 1.29.3 2.09 1.58 1.78 2.84l0 0C1103.13 1201.23 1101.81 1202.02 1100.52 1201.72z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1154.55 1247.32c-80.44-18.66-120.49-28.2-199.28-47.83-1.27-.32-2.06-1.59-1.74-2.82l0 0c.32-1.23 1.62-1.98 2.9-1.67 78.79 19.57 118.83 29.08 199.25 47.69 1.3.3 2.11 1.59 1.8 2.86l0 0C1157.17 1246.83 1155.85 1247.62 1154.55 1247.32zM1089.28 1246.59c-55.42-13.21-82.99-19.92-137.49-33.62-1.28-.32-2.06-1.59-1.74-2.83l0 0c.32-1.24 1.62-1.99 2.9-1.67 54.5 13.66 82.06 20.36 137.47 33.53 1.3.31 2.1 1.59 1.78 2.85l0 0C1091.9 1246.12 1090.58 1246.9 1089.28 1246.59z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1143.95 1290.85c-80.68-19.03-120.83-28.77-199.6-48.84-1.28-.32-2.06-1.61-1.74-2.85l0 0c.32-1.24 1.62-2 2.9-1.67 78.77 20.04 118.91 29.76 199.56 48.76 1.31.31 2.12 1.6 1.81 2.86l0 0C1146.57 1290.37 1145.25 1291.16 1143.95 1290.85zM1078.55 1289.82c-55.56-13.42-83.17-20.26-137.67-34.21-1.28-.33-2.06-1.61-1.74-2.86l0 0c.32-1.25 1.62-2 2.89-1.68 54.5 13.93 82.11 20.76 137.65 34.17 1.3.31 2.11 1.6 1.79 2.86l0 0C1081.17 1289.36 1079.85 1290.13 1078.55 1289.82z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1488.16 781.44c-45.04-5.59-67.52-8.39-112.55-14.01-1.07-.13-1.74-1.12-1.49-2.19.07-.29.1-.44.17-.73.25-1.07 1.32-1.84 2.39-1.71 45.01 5.61 67.49 8.4 112.5 13.99 1.07.13 1.75 1.12 1.51 2.2-.07.3-.1.44-.16.74C1490.3 780.79 1489.23 781.57 1488.16 781.44zM1485.1 795.48c-45.09-5.63-67.6-8.45-112.69-14.11-1.07-.13-1.74-1.12-1.49-2.2.07-.3.1-.44.17-.74.25-1.08 1.32-1.85 2.39-1.71 45.07 5.64 67.57 8.46 112.64 14.07 1.07.13 1.75 1.13 1.51 2.22-.07.3-.1.45-.16.74C1487.24 794.83 1486.17 795.61 1485.1 795.48zM1458.69 806.68c-35.88-4.52-53.81-6.79-89.7-11.33-.96-.12-1.56-1.01-1.33-1.98.11-.46.16-.69.27-1.16.22-.97 1.19-1.66 2.14-1.54 35.88 4.53 53.8 6.78 89.67 11.29.96.12 1.56 1.02 1.35 1.99-.1.47-.16.7-.26 1.17C1460.6 806.1 1459.64 806.8 1458.69 806.68z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1670.38 803.94c-45.39-5.57-67.98-8.35-113.1-13.94-1.07-.13-1.76-1.13-1.53-2.21.06-.3.09-.44.16-.74.23-1.08 1.29-1.86 2.36-1.72 45.1 5.57 67.68 8.36 113.06 13.92 1.08.13 1.78 1.13 1.56 2.21-.06.3-.09.45-.15.74C1672.51 803.29 1671.45 804.07 1670.38 803.94zM1667.5 818.11c-45.42-5.59-68.03-8.4-113.2-14.01-1.07-.13-1.76-1.14-1.53-2.23.06-.3.09-.45.16-.75.23-1.09 1.3-1.87 2.37-1.74 45.15 5.6 67.76 8.4 113.17 13.98 1.08.13 1.77 1.14 1.55 2.23-.06.3-.09.45-.15.75C1669.64 817.45 1668.58 818.24 1667.5 818.11zM1641.12 829.51c-36.09-4.48-54.09-6.73-90.04-11.23-.96-.12-1.57-1.02-1.36-2 .1-.47.15-.71.25-1.18.21-.98 1.16-1.69 2.12-1.57 35.94 4.49 53.93 6.73 90.01 11.2.96.12 1.58 1.02 1.38 2.01-.1.47-.15.71-.24 1.18C1643.03 828.92 1642.08 829.63 1641.12 829.51z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1854.87 826.37c-46.17-5.56-69.08-8.33-114.71-13.89-1.08-.13-1.79-1.13-1.57-2.22.06-.3.09-.45.15-.74.22-1.09 1.28-1.87 2.36-1.73 45.63 5.56 68.54 8.33 114.71 13.88 1.09.13 1.81 1.13 1.6 2.22-.06.3-.09.45-.15.75C1857.04 825.71 1855.97 826.5 1854.87 826.37zM1852.04 840.63c-46.15-5.58-69.07-8.36-114.72-13.95-1.08-.13-1.79-1.14-1.56-2.24.06-.3.09-.45.15-.75.22-1.1 1.28-1.89 2.37-1.76 45.65 5.58 68.56 8.36 114.72 13.93 1.09.13 1.81 1.14 1.59 2.25-.06.3-.09.45-.15.76C1854.21 839.97 1853.13 840.76 1852.04 840.63zM1825.36 852.2c-36.6-4.46-54.8-6.69-91.12-11.17-.97-.12-1.6-1.03-1.4-2.03.1-.48.14-.72.24-1.19.2-.99 1.15-1.71 2.12-1.59 36.31 4.46 54.52 6.69 91.11 11.14.97.12 1.61 1.03 1.41 2.03-.1.48-.14.72-.24 1.2C1827.29 851.6 1826.33 852.32 1825.36 852.2z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1432.8,856.56c-17.33-2.29-25.99-3.44-43.31-5.73c2.51-10.95,3.76-16.41,6.24-27.28 c17.29,2.23,25.93,3.34,43.23,5.56C1436.51,840.05,1435.28,845.54,1432.8,856.56z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 1393.044,
    x2: 1420.829,
    y1: 871.72,
    y2: 871.72,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M1409.74,841.68c-0.92-3.49-1.37-5.23-2.29-8.7c-1.72,0.51-2.58,0.76-4.3,1.27 c1.23,4.69,1.85,7.04,3.09,11.74c9.42-2.25,14.12-3.38,23.53-5.64c0.33-1.47,0.5-2.21,0.83-3.68 C1422.25,838.68,1418.09,839.68,1409.74,841.68z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1412.57,946.18c-17.42-2.59-26.13-3.9-43.55-6.51c2.57-11.12,3.86-16.67,6.42-27.74 c17.39,2.5,26.09,3.75,43.48,6.23C1416.38,929.34,1415.11,934.95,1412.57,946.18z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 1372.482,
    x2: 1400.434,
    y1: 961.397,
    y2: 961.397,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M1389.43,930.64c-0.9-3.57-1.35-5.36-2.26-8.92c-1.74,0.5-2.6,0.74-4.34,1.24 c1.22,4.8,1.83,7.21,3.05,12.03c9.49-2.16,14.23-3.24,23.71-5.43c0.34-1.5,0.51-2.25,0.85-3.75 C1402.04,927.75,1397.84,928.72,1389.43,930.64z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1391.91,1036.95c-17.51-2.99-26.26-4.48-43.76-7.49c2.6-11.18,3.91-16.78,6.5-27.95 c17.48,2.88,26.22,4.31,43.7,7.17C1395.78,1019.98,1394.49,1025.64,1391.91,1036.95z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 1351.466,
    x2: 1379.557,
    y1: 1052.241,
    y2: 1052.241,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M1368.69,1020.74c-0.9-3.64-1.35-5.45-2.25-9.08c-1.74,0.47-2.62,0.7-4.36,1.17 c1.21,4.89,1.82,7.34,3.04,12.25c9.54-1.99,14.31-2.99,23.84-5.02c0.35-1.52,0.52-2.27,0.87-3.79 C1381.38,1018.08,1377.15,1018.97,1368.69,1020.74z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1371.17,1127.91c-17.59-3.39-26.38-5.1-43.96-8.51c2.6-11.15,3.9-16.74,6.5-27.91 c17.56,3.29,26.34,4.93,43.9,8.2C1375.03,1110.99,1373.74,1116.63,1371.17,1127.91z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 1330.292,
    x2: 1358.513,
    y1: 1143.376,
    y2: 1143.376,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M1347.82,1111.12c-0.91-3.67-1.36-5.5-2.27-9.17c-1.75,0.43-2.63,0.64-4.38,1.07 c1.22,4.94,1.84,7.41,3.06,12.36c9.58-1.77,14.37-2.67,23.94-4.49c0.35-1.51,0.52-2.27,0.87-3.78 C1360.55,1108.74,1356.31,1109.54,1347.82,1111.12z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1350.63,1218.06c-17.68-3.74-26.52-5.62-44.19-9.4c2.56-11.02,3.84-16.54,6.41-27.62 c17.64,3.67,26.47,5.51,44.12,9.15C1354.43,1201.37,1353.16,1206.95,1350.63,1218.06z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 1309.255,
    x2: 1337.614,
    y1: 1233.924,
    y2: 1233.924,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M1327.1,1200.9c-0.93-3.67-1.39-5.5-2.32-9.17c-1.76,0.39-2.64,0.58-4.4,0.97 c1.25,4.94,1.88,7.41,3.13,12.35c9.61-1.55,14.42-2.33,24.03-3.93c0.34-1.49,0.51-2.24,0.85-3.74 C1339.88,1198.81,1335.63,1199.51,1327.1,1200.9z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1330.63,1306.43c-17.8-3.97-26.69-5.97-44.48-9.98c2.48-10.79,3.73-16.2,6.23-27.07 c17.75,3.96,26.63,5.92,44.39,9.84C1334.3,1290.15,1333.07,1295.6,1330.63,1306.43z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 1288.654,
    x2: 1317.179,
    y1: 1323.006,
    y2: 1323.006,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M1306.85,1289.18c-0.96-3.62-1.44-5.43-2.4-9.05c-1.76,0.35-2.64,0.52-4.41,0.87 c1.29,4.88,1.94,7.32,3.24,12.2c9.64-1.35,14.47-2.04,24.1-3.42c0.33-1.46,0.5-2.19,0.83-3.65 C1319.67,1287.36,1315.4,1287.98,1306.85,1289.18z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1618.61,880.9c-17.4-2.26-26.09-3.39-43.46-5.65c2.38-11.26,3.56-16.86,5.89-27.98 c17.34,2.2,26.02,3.3,43.39,5.5C1622.13,863.94,1620.96,869.57,1618.61,880.9z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 1580.83,
    x2: 1608.703,
    y1: 888.361,
    y2: 888.361,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M1595.32,865.75c-0.96-3.57-1.44-5.35-2.41-8.9c-1.72,0.53-2.58,0.79-4.29,1.32 c1.3,4.79,1.95,7.2,3.24,12.02c9.4-2.35,14.11-3.53,23.51-5.89c0.31-1.51,0.47-2.26,0.78-3.77 C1607.82,862.62,1603.65,863.66,1595.32,865.75z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1599.27,973.67c-17.45-2.54-26.18-3.82-43.62-6.37c2.46-11.59,3.69-17.37,6.14-28.88 c17.42,2.45,26.14,3.67,43.57,6.12C1602.94,956.15,1601.72,961.98,1599.27,973.67z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 1561.276,
    x2: 1589.272,
    y1: 980.995,
    y2: 980.995,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M1575.98,957.73c-0.94-3.7-1.41-5.55-2.35-9.24c-1.73,0.53-2.6,0.79-4.33,1.32 c1.27,4.98,1.9,7.47,3.17,12.47c9.47-2.32,14.2-3.49,23.67-5.84c0.33-1.56,0.49-2.34,0.82-3.9 C1588.57,954.63,1584.37,955.66,1575.98,957.73z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1579.38,1068.52c-17.5-2.91-26.25-4.37-43.76-7.3c2.5-11.72,3.76-17.58,6.25-29.29 c17.49,2.81,26.23,4.21,43.72,7C1583.11,1050.75,1581.86,1056.67,1579.38,1068.52z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 1541.104,
    x2: 1569.193,
    y1: 1075.823,
    y2: 1075.823,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M1556.06,1051.86c-0.93-3.79-1.39-5.68-2.33-9.46c-1.74,0.51-2.61,0.76-4.35,1.27 c1.26,5.1,1.88,7.65,3.14,12.76c9.51-2.19,14.26-3.29,23.77-5.52c0.33-1.59,0.5-2.38,0.83-3.96 C1568.7,1048.93,1564.49,1049.91,1556.06,1051.86z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1559.37,1163.71c-17.55-3.3-26.32-4.95-43.89-8.27c2.49-11.66,3.74-17.51,6.24-29.21 c17.55,3.2,26.31,4.79,43.85,7.97C1563.09,1146.02,1561.84,1151.93,1559.37,1163.71z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 1520.736,
    x2: 1548.908,
    y1: 1171.215,
    y2: 1171.215,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M1535.97,1146.53c-0.94-3.81-1.41-5.72-2.34-9.53c-1.74,0.47-2.62,0.71-4.36,1.18 c1.26,5.14,1.89,7.71,3.16,12.85c9.54-1.98,14.3-2.98,23.83-5.01c0.33-1.58,0.5-2.37,0.83-3.96 C1548.64,1143.87,1544.42,1144.76,1535.97,1146.53z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1539.7,1257.51c-17.6-3.63-26.41-5.45-44.05-9.1c2.43-11.41,3.65-17.15,6.11-28.66 c17.61,3.56,26.41,5.33,43.99,8.87C1543.31,1240.23,1542.1,1246.01,1539.7,1257.51z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 1500.597,
    x2: 1528.858,
    y1: 1265.546,
    y2: 1265.546,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M1516.14,1240.1c-0.96-3.78-1.44-5.67-2.4-9.45c-1.74,0.43-2.62,0.64-4.36,1.06 c1.29,5.1,1.94,7.64,3.24,12.73c9.55-1.73,14.32-2.61,23.86-4.39c0.32-1.55,0.49-2.33,0.81-3.88 C1528.83,1237.76,1524.6,1238.55,1516.14,1240.1z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1520.8,1348.2c-17.68-3.83-26.54-5.76-44.26-9.62c2.31-10.97,3.48-16.5,5.84-27.62 c17.7,3.82,26.54,5.71,44.19,9.5C1524.23,1331.64,1523.08,1337.19,1520.8,1348.2z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 1481.109,
    x2: 1509.487,
    y1: 1357.186,
    y2: 1357.186,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M1496.99,1330.95c-1-3.67-1.5-5.51-2.5-9.19c-1.75,0.38-2.62,0.57-4.37,0.94 c1.35,4.96,2.02,7.43,3.38,12.37c9.56-1.48,14.33-2.24,23.87-3.76c0.31-1.49,0.47-2.24,0.78-3.73 C1509.7,1328.95,1505.47,1329.63,1496.99,1330.95z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1805.74,904.96c-17.57-2.24-26.34-3.36-43.86-5.6c2.31-11.55,3.46-17.27,5.73-28.61 c17.52,2.18,26.3,3.28,43.88,5.46C1809.21,887.59,1808.06,893.35,1805.74,904.96z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 1769.863,
    x2: 1798.025,
    y1: 904.691,
    y2: 904.691,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M1782.14,889.56c-0.99-3.64-1.49-5.46-2.49-9.08c-1.73,0.54-2.59,0.82-4.32,1.36 c1.35,4.89,2.02,7.34,3.36,12.27c9.47-2.45,14.21-3.67,23.69-6.11c0.31-1.54,0.46-2.31,0.77-3.85 C1794.74,886.31,1790.54,887.39,1782.14,889.56z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1786.52,1000.69c-17.52-2.51-26.28-3.76-43.79-6.27c2.43-12.03,3.64-18.03,6.04-29.94 c17.51,2.42,26.27,3.62,43.81,6.03C1790.17,982.51,1788.96,988.55,1786.52,1000.69z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 1750.676,
    x2: 1778.806,
    y1: 1000.095,
    y2: 1000.095,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M1763.1,984.35c-0.95-3.83-1.43-5.74-2.39-9.55c-1.73,0.56-2.6,0.84-4.34,1.4 c1.29,5.14,1.93,7.72,3.22,12.89c9.5-2.48,14.25-3.72,23.75-6.22c0.32-1.62,0.49-2.43,0.81-4.04 C1775.73,981.04,1771.52,982.15,1763.1,984.35z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1766.61,1099.4c-17.47-2.86-26.2-4.29-43.68-7.16c2.48-12.23,3.72-18.35,6.19-30.55 c17.49,2.75,26.23,4.13,43.71,6.87C1770.35,1080.87,1769.1,1087.05,1766.61,1099.4z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 1730.707,
    x2: 1758.773,
    y1: 1098.717,
    y2: 1098.717,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M1743.33,1082.29c-0.93-3.93-1.4-5.9-2.34-9.82c-1.74,0.55-2.61,0.82-4.34,1.36 c1.26,5.29,1.89,7.94,3.15,13.25c9.49-2.37,14.24-3.57,23.74-5.98c0.33-1.65,0.5-2.48,0.83-4.13 C1755.95,1079.12,1751.74,1080.18,1743.33,1082.29z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1746.58,1198.61c-17.4-3.23-26.11-4.84-43.56-8.08c2.46-12.15,3.69-18.24,6.17-30.45 c17.45,3.13,26.17,4.69,43.6,7.8C1750.3,1180.2,1749.05,1186.35,1746.58,1198.61z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 1710.504,
    x2: 1738.496,
    y1: 1198.179,
    y2: 1198.179,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M1723.36,1181.03c-0.93-3.95-1.4-5.93-2.33-9.89c-1.73,0.51-2.6,0.77-4.33,1.28 c1.26,5.33,1.89,7.99,3.15,13.32c9.47-2.17,14.2-3.26,23.67-5.47c0.33-1.65,0.5-2.47,0.83-4.12 C1735.95,1178.12,1731.75,1179.09,1723.36,1181.03z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1727,1295.85c-17.35-3.54-26.05-5.31-43.48-8.87c2.38-11.78,3.57-17.71,5.98-29.63 c17.43,3.47,26.13,5.2,43.5,8.65C1730.58,1278.02,1729.38,1283.99,1727,1295.85z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 1690.621,
    x2: 1718.544,
    y1: 1296.104,
    y2: 1296.104,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M1703.75,1278.19c-0.95-3.88-1.43-5.83-2.38-9.72c-1.72,0.46-2.59,0.69-4.31,1.15 c1.28,5.24,1.93,7.86,3.22,13.09c9.43-1.9,14.14-2.86,23.55-4.8c0.32-1.6,0.48-2.4,0.81-4.01 C1716.29,1275.63,1712.11,1276.49,1703.75,1278.19z",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1708.43,1388.65c-17.32-3.73-26.02-5.6-43.44-9.35c2.22-11.12,3.35-16.75,5.62-28.1 c17.43,3.71,26.12,5.56,43.45,9.24C1711.78,1371.85,1710.65,1377.5,1708.43,1388.65z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 1671.607,
    x2: 1699.485,
    y1: 1390.113,
    y2: 1390.113,
    gradientTransform: "matrix(.9877 .0394 0 1 27.255 -87.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003aff",
    className: "stopColorffb000 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M1685.05,1371.39c-1-3.71-1.49-5.57-2.48-9.31c-1.71,0.4-2.57,0.6-4.29,1 c1.34,5.03,2.01,7.53,3.36,12.53c9.38-1.59,14.06-2.4,23.42-4.03c0.3-1.52,0.46-2.27,0.76-3.79 C1697.52,1369.24,1693.36,1369.97,1685.05,1371.39z",
    opacity: 0.56
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2119.08,
    cy: 1315.09,
    fill: "#00114c",
    opacity: 0,
    rx: 559.95,
    ry: 209.21,
    transform: "rotate(-50.767 2119.036 1315.054)",
    className: "color4c0000 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2115.26,
    cy: 1319.45,
    fill: "#01124a",
    opacity: 0.038,
    rx: 546.4,
    ry: 204.15,
    transform: "rotate(-50.767 2115.216 1319.41)",
    className: "color4a0101 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2111.44,
    cy: 1323.8,
    fill: "#021248",
    opacity: 0.077,
    rx: 532.85,
    ry: 199.09,
    transform: "rotate(-50.767 2111.396 1323.766)",
    className: "color480202 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2107.62,
    cy: 1328.16,
    fill: "#031246",
    opacity: 0.115,
    rx: 519.3,
    ry: 194.02,
    transform: "rotate(-50.767 2107.576 1328.123)",
    className: "color460303 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2103.8,
    cy: 1332.52,
    fill: "#041344",
    opacity: 0.154,
    rx: 505.75,
    ry: 188.96,
    transform: "rotate(-50.767 2103.756 1332.479)",
    className: "color440404 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2099.98,
    cy: 1336.87,
    fill: "#051342",
    opacity: 0.192,
    rx: 492.19,
    ry: 183.9,
    transform: "rotate(-50.767 2099.937 1336.835)",
    className: "color420505 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2096.16,
    cy: 1341.23,
    fill: "#061340",
    opacity: 0.231,
    rx: 478.64,
    ry: 178.83,
    transform: "rotate(-50.767 2096.117 1341.192)",
    className: "color400606 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2092.34,
    cy: 1345.59,
    fill: "#06133e",
    opacity: 0.269,
    rx: 465.09,
    ry: 173.77,
    transform: "rotate(-50.767 2092.297 1345.548)",
    className: "color3e0606 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2088.52,
    cy: 1349.94,
    fill: "#07133c",
    opacity: 0.308,
    rx: 451.54,
    ry: 168.71,
    transform: "rotate(-50.767 2088.477 1349.904)",
    className: "color3c0707 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2084.7,
    cy: 1354.3,
    fill: "#08133a",
    opacity: 0.346,
    rx: 437.99,
    ry: 163.64,
    transform: "rotate(-50.767 2084.658 1354.26)",
    className: "color3a0808 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2080.88,
    cy: 1358.66,
    fill: "#091438",
    opacity: 0.385,
    rx: 424.43,
    ry: 158.58,
    transform: "rotate(-50.767 2080.837 1358.617)",
    className: "color380909 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2077.06,
    cy: 1363.01,
    fill: "#0a1436",
    opacity: 0.423,
    rx: 410.88,
    ry: 153.52,
    transform: "rotate(-50.767 2077.018 1362.973)",
    className: "color360a0a svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2073.24,
    cy: 1367.37,
    fill: "#0b1434",
    opacity: 0.462,
    rx: 397.33,
    ry: 148.45,
    transform: "rotate(-50.767 2073.198 1367.33)",
    className: "color340b0b svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2069.42,
    cy: 1371.72,
    fill: "#0c1533",
    opacity: 0.5,
    rx: 383.78,
    ry: 143.39,
    transform: "rotate(-50.767 2069.378 1371.686)",
    className: "color330c0c svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2065.6,
    cy: 1376.08,
    fill: "#0d1531",
    opacity: 0.538,
    rx: 370.23,
    ry: 138.33,
    transform: "rotate(-50.767 2065.558 1376.042)",
    className: "color310d0d svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2061.78,
    cy: 1380.44,
    fill: "#0e162f",
    opacity: 0.577,
    rx: 356.67,
    ry: 133.26,
    transform: "rotate(-50.767 2061.739 1380.399)",
    className: "color2f0e0e svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2057.96,
    cy: 1384.79,
    fill: "#0f162d",
    opacity: 0.615,
    rx: 343.12,
    ry: 128.2,
    transform: "rotate(-50.767 2057.919 1384.755)",
    className: "color2d0f0f svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2054.14,
    cy: 1389.15,
    fill: "#10162b",
    opacity: 0.654,
    rx: 329.57,
    ry: 123.14,
    transform: "rotate(-50.767 2054.099 1389.111)",
    className: "color2b1010 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2050.32,
    cy: 1393.51,
    fill: "#111729",
    opacity: 0.692,
    rx: 316.02,
    ry: 118.07,
    transform: "rotate(-50.767 2050.28 1393.468)",
    className: "color291111 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2046.5,
    cy: 1397.86,
    fill: "#121727",
    opacity: 0.731,
    rx: 302.47,
    ry: 113.01,
    transform: "rotate(-50.767 2046.46 1397.824)",
    className: "color271212 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2042.68,
    cy: 1402.22,
    fill: "#121625",
    opacity: 0.769,
    rx: 288.91,
    ry: 107.95,
    transform: "rotate(-50.767 2042.64 1402.18)",
    className: "color251212 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2038.86,
    cy: 1406.58,
    fill: "#131723",
    opacity: 0.808,
    rx: 275.36,
    ry: 102.88,
    transform: "rotate(-50.767 2038.82 1406.537)",
    className: "color231313 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2035.04,
    cy: 1410.93,
    fill: "#141721",
    opacity: 0.846,
    rx: 261.81,
    ry: 97.82,
    transform: "rotate(-50.767 2035 1410.893)",
    className: "color211414 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2031.22,
    cy: 1415.29,
    fill: "#15171f",
    opacity: 0.885,
    rx: 248.26,
    ry: 92.76,
    transform: "rotate(-50.767 2031.18 1415.25)",
    className: "color1f1515 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2027.4,
    cy: 1419.65,
    fill: "#16181d",
    opacity: 0.923,
    rx: 234.71,
    ry: 87.69,
    transform: "rotate(-50.767 2027.36 1419.606)",
    className: "color1d1616 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2023.58,
    cy: 1424,
    fill: "#17181b",
    opacity: 0.962,
    rx: 221.15,
    ry: 82.63,
    transform: "rotate(-50.767 2023.541 1423.962)",
    className: "color1b1717 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2019.76,
    cy: 1428.36,
    fill: "#181819",
    rx: 207.6,
    ry: 77.57,
    transform: "rotate(-50.767 2019.721 1428.318)",
    className: "color191818 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 509.893,
    x2: 1044.04,
    y1: 977.668,
    y2: 1002.26,
    gradientTransform: "rotate(-9.079 2270.238 1259.157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M845.19,1406.66l-50.48-31.93c-11.94,10.66-25.15,19.76-39.25,26.95l12.85,57.8 c-30.07,13.04-62.44,20.26-95.22,20.6l-12.74-57.73c-15.77-0.79-31.49-3.52-46.83-8.25l-32.34,49.83 c-15.07-5.62-29.6-13-43.62-21.87s-27-18.88-38.36-29.98l32.34-49.83c-10.87-11.85-20.06-24.88-27.38-38.69l-58.27,12.66 c-13.28-29.47-20.34-61.49-20.73-93.94l58.27-12.66c0.83-15.58,3.58-31.3,8.51-46.4l-50.37-31.86 c5.71-14.9,13.28-29.38,22.29-43.25c9-13.87,19.09-26.61,30.42-37.96l50.37,31.86c11.9-10.84,24.97-19.72,39.07-26.91 l-12.74-57.73c30.07-13.04,62.55-20.19,95.29-20.7l12.63,57.66c15.77,0.79,31.6,3.58,47.05,8.39l32.41-49.94 c14.89,5.66,29.53,13.11,43.55,21.98s26.89,18.82,38.43,29.87l-32.41,49.94c10.77,11.78,19.85,24.75,27.16,38.55l58.52-12.81 c13.25,29.75,20.24,61.87,20.7,94.22l-58.56,12.63c-0.62,15.72-3.44,31.09-8.33,46.36l50.48,31.93 c-5.82,14.83-13.22,29.27-22.22,43.14C866.67,1382.47,856.41,1395.24,845.19,1406.66z M611.66,1327.88 c49.94,31.59,116.36,17.16,148.5-32.35c32.07-49.41,17.59-115.01-32.35-146.6c-49.94-31.59-116.47-17.23-148.54,32.18 C547.13,1230.62,561.71,1296.29,611.66,1327.88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 806.867,
    x2: 861.252,
    y1: 770.734,
    y2: 770.734,
    gradientTransform: "rotate(-12.258 2005.842 1258.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#az)",
    points: "758.36 1012.78 779.29 1004.39 746.88 1054.33 733.71 1050.75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 665.476,
    x2: 666.582,
    y1: 710.625,
    y2: 769.775,
    gradientTransform: "rotate(-12.258 2005.842 1258.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aA)",
    points: "570.97 1017.37 591.91 1008.99 604.65 1066.71 583.71 1075.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 569.739,
    x2: 523.445,
    y1: 750.732,
    y2: 817.553,
    gradientTransform: "rotate(-12.258 2005.842 1258.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M494.27,1070.15l20.94-8.39l-52.71,81.2l-20.94,8.39C441.56,1151.36,460.07,1102.78,494.27,1070.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 471.453,
    x2: 475.821,
    y1: 896.12,
    y2: 986.526,
    gradientTransform: "rotate(-12.258 2005.842 1258.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M425.15,1242.27l20.94-8.39l20.73,93.94l-20.94,8.39C445.89,1336.21,424.45,1295.69,425.15,1242.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 580.917,
    x2: 525.451,
    y1: 1167.975,
    y2: 1092.855,
    gradientTransform: "rotate(-12.258 2005.842 1258.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M499.19,1412.08l20.94-8.39l81.98,51.85l-20.94,8.39C581.17,1463.93,534.67,1450.12,499.19,1412.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 666.738,
    x2: 668.485,
    y1: 1135.345,
    y2: 1192.996,
    gradientTransform: "rotate(-12.258 2005.842 1258.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aE)",
    points: "673.09 1480.08 694.02 1471.69 681.28 1413.96 660.35 1422.35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 802.665,
    x2: 862.492,
    y1: 1134.033,
    y2: 1134.033,
    gradientTransform: "rotate(-12.258 2005.842 1258.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aF)",
    points: "866.13 1398.28 845.19 1406.66 800.6 1378.46 815.65 1366.35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 905.615,
    x2: 966.57,
    y1: 1001.42,
    y2: 1001.42,
    gradientTransform: "rotate(-12.258 2005.842 1258.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b2b2",
    className: "stopColorb2b2b2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aG)",
    points: "914.3 1234.54 935.24 1226.16 876.68 1238.79 876.47 1242.76"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 470.432,
    x2: 959.714,
    y1: 981.132,
    y2: 981.132,
    gradientTransform: "rotate(-9.079 2270.238 1259.157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbfb",
    className: "stopColorfbfbfb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    className: "stopColore5e5e5 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M866.13,1398.28l-50.48-31.93c-11.94,10.66-25.15,19.76-39.25,26.95l12.85,57.8 c-30.07,13.04-62.44,20.26-95.22,20.6l-12.74-57.73c-15.77-0.79-31.49-3.52-46.83-8.25l-32.34,49.83 c-15.07-5.62-29.6-13-43.62-21.87c-14.02-8.87-27-18.88-38.36-29.98l32.34-49.83c-10.87-11.85-20.06-24.88-27.38-38.69 l-58.27,12.66c-13.28-29.47-20.34-61.49-20.73-93.94l58.27-12.66c0.83-15.58,3.58-31.3,8.51-46.4l-50.37-31.86 c5.71-14.9,13.28-29.38,22.29-43.25c9-13.87,19.09-26.61,30.42-37.96l50.37,31.86c11.9-10.84,24.97-19.72,39.07-26.91 l-12.74-57.73c30.07-13.04,62.55-20.19,95.29-20.7l12.63,57.66c15.77,0.79,31.6,3.58,47.05,8.39l32.41-49.94 c14.89,5.66,29.53,13.11,43.55,21.98c14.02,8.87,26.89,18.82,38.43,29.87l-32.41,49.94c10.77,11.78,19.85,24.75,27.16,38.55 l58.52-12.81c13.25,29.75,20.24,61.87,20.7,94.22l-58.56,12.63c-0.62,15.72-3.44,31.09-8.33,46.36l50.48,31.93 c-5.82,14.83-13.22,29.27-22.22,43.14C887.61,1374.09,877.34,1386.86,866.13,1398.28z M632.59,1319.5 c49.94,31.59,116.36,17.16,148.5-32.35c32.07-49.41,17.59-115.01-32.35-146.6c-49.94-31.59-116.47-17.23-148.54,32.18 C568.07,1222.24,582.65,1287.91,632.59,1319.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M504.44 1220.58l.39-.09c.83-15.58 3.58-31.3 8.51-46.4l-50.37-31.86c5.66-14.75 13.16-29.08 22.04-42.83-.07.11-.15.2-.23.31-9 13.87-16.57 28.35-22.29 43.25l50.37 31.86C508.01 1189.72 505.31 1205.22 504.44 1220.58zM605.12 1065.98l-12.63-57.22c-.19.08-.39.14-.58.22l12.65 57.33C604.76 1066.22 604.93 1066.08 605.12 1065.98zM781.56 1286.41c32.07-49.41 17.59-115.01-32.35-146.6-49.94-31.59-116.47-17.23-148.54 32.18-.09.13-.13.28-.21.41 32.15-49.12 98.46-63.37 148.28-31.86 49.81 31.51 64.3 96.83 32.56 146.19C781.38 1286.62 781.48 1286.53 781.56 1286.41z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "829.33 1105.46 861.27 1056.24 861.27 1056.24 829.33 1105.45",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M866.6 1397.55l-50.48-31.93c-11.94 10.66-25.15 19.76-39.25 26.95l.09.4c13.88-7.14 26.92-16.1 38.69-26.62l50.48 31.93c11.21-11.42 21.48-24.19 30.49-38.06.09-.13.15-.27.24-.41C887.9 1373.55 877.72 1386.22 866.6 1397.55zM877.15 1238.06c-.01.22-.06.43-.07.64l58.16-12.54c0-.21-.04-.41-.04-.62L877.15 1238.06zM552.47 1353.86l.47-.73c-10.88-11.85-20.06-24.88-27.38-38.69l-58.27 12.66c-13.19-29.28-20.22-61.08-20.69-93.32l-.51.11c.39 32.45 7.45 64.47 20.73 93.94l58.27-12.66C532.41 1328.98 541.6 1342.01 552.47 1353.86zM694.49 1470.96l-12.74-57.73c-15.77-.79-31.49-3.52-46.83-8.25l-32.34 49.83c-15.07-5.62-29.6-13-43.62-21.87-14.02-8.87-26.99-18.88-38.35-29.98l-.47.73c11.36 11.1 24.33 21.11 38.36 29.98 14.02 8.87 28.55 16.25 43.62 21.87l32.34-49.83c15.34 4.73 31.07 7.46 46.83 8.25l12.74 57.73c32.78-.34 65.15-7.55 95.22-20.6l-.11-.51C759.22 1463.47 727.06 1470.62 694.49 1470.96z",
    className: "colorffffff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 1580.826,
    x2: 1640.579,
    y1: 2018.447,
    y2: 2104.246,
    gradientTransform: "matrix(.7724 -.607 .5666 .824 -412.506 1026.045)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c43fe",
    className: "stopColorfe810c svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M2044.34,1515.82c-38.13-12.82-59.38,33-75.27,52.89c0,0-35.65,42.73-10.58,122.85 c16.86,53.88,5.54,60.98-20.78,102.02c-50.88,79.34,12.94,182.68,12.94,182.68s-14.48-110.78,67.85-138.29 c82.33-27.51,79.55-75.98,70.16-112.01c-7-26.86,16.28-72.01,35.1-89.67c3.23-2.31,18.77-18.49,21.17-21.43 C2143.73,1588.1,2082.71,1528.99,2044.34,1515.82z",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 1841.288,
    x2: 1949.912,
    y1: 1383.521,
    y2: 1436.57,
    gradientTransform: "rotate(-5.514 1341.241 1233.701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M2029.68,1133.75l-156.97,106.91c-26.24,17.86-41.83,47.63-41.58,79.37l2.17,267.57 c0,0,4.4,10.96,8.7,9.53c12.89-4.27,37.23-28.86,37.97-66.17c0.99-49.75,101.67-129.34,101.67-129.34L2029.68,1133.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 1822.043,
    x2: 2004.681,
    y1: 1407,
    y2: 1460.717,
    gradientTransform: "rotate(-5.514 1341.241 1233.701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d4fd",
    className: "stopColorc8ecfd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M2015.97,1158.6l-134.57,91.59c-26.24,17.86-41.83,47.63-41.58,79.37l2.17,267.57 c0,0,45.68-6.89,46.67-56.64c0.99-49.75,101.67-129.34,101.67-129.34L2015.97,1158.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 1833.041,
    x2: 1971.676,
    y1: 1349.643,
    y2: 1390.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M1842,1330.41c-0.26-31.74,15.34-61.51,41.58-79.37l132.14-89.93l0.25-2.51l-134.57,91.59 c-26.24,17.86-41.83,47.63-41.58,79.37l2.17,267.57c0,0,0.82-0.14,2.16-0.45L1842,1330.41z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 444.268,
    x2: 552.892,
    y1: 635.653,
    y2: 688.702,
    gradientTransform: "matrix(-.6387 -.7694 -.7695 .6386 3153.584 1462.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M2397.24,1259.3l36.08,186.44c6.04,31.15-3.87,63.27-26.41,85.61l-190.06,188.33 c0,0-10.84,4.67-12.89,0.64c-6.14-12.11-6.08-46.7,19.68-73.7c34.35-36,18.97-163.41,18.97-163.41L2397.24,1259.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 448.554,
    x2: 557.178,
    y1: 653.057,
    y2: 706.106,
    gradientTransform: "matrix(-.6387 -.7694 -.7695 .6386 3153.584 1462.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M2389.46,1286.59l30.97,159.79c6.04,31.15-3.87,63.27-26.41,85.61l-190.06,188.33 c0,0-27.56-37.07,6.79-73.07c34.35-36,18.97-163.41,18.97-163.41L2389.46,1286.59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 2450.468,
    x2: 2274.287,
    y1: 1567.184,
    y2: 1494.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M2420.43,1446.38l-30.97-159.79l-2.1,2.6l30.47,157.19c6.04,31.16-3.87,63.27-26.41,85.61l-188.49,186.78 c0.63,0.99,1.04,1.55,1.04,1.55l190.06-188.33C2416.56,1509.65,2426.47,1477.53,2420.43,1446.38z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 2158.912,
    x2: 1931.374,
    y1: 1663.8,
    y2: 1548.088,
    gradientTransform: "rotate(-5.514 1341.241 1233.701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00196d",
    className: "stopColor343442 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6f7f",
    className: "stopColor6a6a7f svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M2228.63,1501.26l-74.01,103.41c-17.04,25.47-63.56,32.13-109.6,13.95 c-46.27-18.16-75.78-54.54-70.76-84.86l15.58-122.8l0.5,0.19c-4.86,39.46,33.6,86.28,93.13,109.66 c61.53,24.14,123.49,15.28,144.92-19.52L2228.63,1501.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 1997.269,
    x2: 2374.38,
    y1: 1141.039,
    y2: 1348.14,
    gradientTransform: "rotate(-5.514 1341.241 1233.701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefeff",
    className: "stopColorfefeff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#d7d8dc",
    className: "stopColord7d7dc svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9699a4",
    className: "stopColor9696a4 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M2562.3,926.37c-1.62,8.1-3.75,16-6.09,24.17c-6.59,23.98-15.52,48.67-26.86,73.35 c-109.28,239.17-250.81,416-288.34,461.01c-6.27,7.34-11.59,14.59-12.4,16.12l0.02,0.24l-0.24,0.02 c-21.43,34.8-83.39,43.66-144.92,19.52c-59.53-23.37-97.98-70.2-93.13-109.66c0.17-0.74,0.12-1.21,0.29-1.95 c0.25-2.43,1.87-15.58,2.08-23.3c2.51-63.78,16.46-285.8,93.56-531.74c7.35-23.57,16.27-45.85,26.07-66.53 c4.8-10.09,9.87-19.96,15.21-29.38c18.6,65.59,86.94,132.88,182.01,170.39C2406.87,966.64,2504.53,963.72,2562.3,926.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193593",
    d: "M2561.45,928.29c-57.76,37.34-155.43,40.27-252.71,2.25c-95.07-37.51-163.41-104.8-182.01-170.39 c118-211.13,350.08-262.65,350.08-262.65l0.24-0.02C2477.03,497.48,2615.63,691.79,2561.45,928.29z",
    className: "color196593 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 2306.427,
    x2: 2594.3,
    y1: 750.814,
    y2: 891.404,
    gradientTransform: "rotate(-5.514 1341.241 1233.701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d4fd",
    className: "stopColorc8ecfd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M2562.3,926.37c-57.76,37.34-155.43,40.27-252.71,2.25c-95.07-37.51-163.41-104.8-182.01-170.39 c118-211.13,350.08-262.65,350.08-262.65l0.24-0.02C2477.89,495.56,2616.48,689.87,2562.3,926.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 2077.904,
    x2: 2161.116,
    y1: 1688.466,
    y2: 1386.472,
    gradientTransform: "rotate(-5.514 1341.241 1233.701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M2096.04,1522.29l63.73-240.07l14.51,4.09l4.9,189.06c0.34,13.03-2.16,25.98-7.32,37.94l-82.49,191.36 l-14.51-4.09c-3.43-4.2-3.27-22.15-1.29-27.2c9.52-24.3,37.06-96.36,35.05-111.76C2106.2,1543.02,2096.04,1522.29,2096.04,1522.29 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 2170.929,
    x2: 2072.06,
    y1: 1549.352,
    y2: 1442.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d4fd",
    className: "stopColorc8ecfd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M2081.53,1518.2l78.24-235.98l4.9,189.06c0.34,13.03-2.16,25.98-7.32,37.94l-82.49,191.36l-13.41-16.44 c-3.43-4.2-4.38-9.8-2.4-14.85c9.52-24.3,37.06-96.36,35.05-111.76C2091.69,1538.93,2081.53,1518.2,2081.53,1518.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 2212.505,
    x2: 2041.54,
    y1: 1467.194,
    y2: 1510.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d4fd",
    className: "stopColorc8ecfd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M2159.77,1282.21l-1.67,5.03l4.75,183.26c0.34,13.03-2.16,25.97-7.32,37.94l-82.07,190.4l1.41,1.72 l82.49-191.36c5.16-11.97,7.66-24.92,7.32-37.94L2159.77,1282.21z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2241.16,
    cy: 1103.99,
    r: 143.14,
    fill: "#0736d3",
    className: "colord36207 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 2188.87,
    x2: 2277.471,
    y1: 1048.384,
    y2: 1175.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003aff",
    className: "stopColorffd600 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c43fe",
    className: "stopColorfe810c svgShape"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2237.7,
    cy: 1118.5,
    r: 143.14,
    fill: "url(#aV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0736d3",
    d: "M2335.77,1159.79c-16.34,38.38-54.2,65.09-98.02,65.09c-58.86,0-106.58-47.71-106.58-106.32 c0-19.19,5.19-37.34,14-52.9c-5.19,12.45-8.04,26.45-8.04,40.97c0,58.86,47.71,106.58,106.58,106.58 C2283.14,1213.21,2317.36,1191.68,2335.77,1159.79z",
    className: "colord36207 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 2174.448,
    x2: 2295.113,
    y1: 1079.49,
    y2: 1139.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d4fd",
    className: "stopColorc8ecfd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#3a66f9",
    className: "stopColor3abaf9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2649bd",
    className: "stopColor267ebd svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M2344.07,1118.56c0,14.52-2.85,28.52-8.04,40.97c0,0,0,0.26-0.26,0.26 c-18.41,31.9-52.64,53.42-92.06,53.42c-58.86,0-106.58-47.71-106.58-106.58c0-14.52,2.85-28.52,8.04-40.97 c0.26-0.26,0.26-0.26,0.26-0.26c18.41-31.9,52.9-53.42,92.32-53.42C2296.36,1011.98,2344.07,1059.69,2344.07,1118.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 2192.226,
    x2: 2262.072,
    y1: 1031.161,
    y2: 1131.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c43fe",
    className: "stopColorfe810c svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M2237.7,977.25c78.74,0,142.58,63.58,143.1,142.2c0-0.32,0.05-0.62,0.05-0.94 c0-79.06-64.09-143.14-143.15-143.14s-143.15,64.09-143.15,143.14c0,0.32,0.05,0.63,0.05,0.94 C2095.12,1040.83,2158.97,977.25,2237.7,977.25z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpoweringAnalytics);
export default __webpack_public_path__ + "static/media/EmpoweringAnalytics.d18c74a838325b0f0a3dab3b71735284.svg";
export { ForwardRef as ReactComponent };